/**
 * Created by zhujunjie on 2017/12/29.
 */
const message = {
  //公共
  common: {
    del_confirm_title:'确认删除',
    del_config_tips1:'您将删除所有已勾选的配置，请确认',
    del_config_tips2:'您将删除所有已勾选的配置，同时设备也会清除这些配置，请确认',

  },
  yd: {
    // 告警信息
    warning: {
      name: '告警信息',
      fence_item: '超出了设备围栏',
      ip_item: '登录IP地址异常',
      no_data: '暂无数据 ~~~',
      fence_title: '设备围栏告警',
      device_lng: '设备经度',
      device_lat: '设备维度',
      fence_lng: '围栏经度',
      fence_lat: '围栏维度',
      fence_radius: '围栏半径',
      login_record_title: '登录IP异常告警',
      login_record_time: '登录时间',
      login_record_current: '本次登录',
      login_record_last: '上次登录',
      password_err_warning: ' 尝试登录，密码错误',
    },
    menu : {
      my_device:'我的设备',
      data_center:'数据中心',
      remote_clear_lockpass : '清除锁屏密码',
      device_restore : '设备还原',
      address_manage : '位置管理',
      restore_date_record:'恢复出厂记录',
      remote_usage_record : '使用记录',
      remote_manage_menu : '远程管理',
      remote_app_manage: '应用管理',
      remote_configuration:'远程设置',
      devicedistributionmanage : '设备归属管理',
      sysCustomization:'系统定制',
      devicedistribution : '设备分发',
      devicedonate : '设备赠送',
      devicedonaterecord : '赠送&接收记录',
      occupyScreen:'霸屏模式',
      silentApp:'默启应用',
      customDesk:'自定义桌面',
      index : '位置',
      dashboard : '主页',
      usermanage : '用户管理',
      userinfo : '用户信息',
      userlist : '用户列表',
      useredit : '用户编辑',
      useradd : '用户添加',
      changepass : '修改密码',
      organization : '机构管理',
      organizationlist : '机构列表',
      organizationadd : '机构添加',
      organizationdetail : '机构详情',
      app : '应用管理',
      applist : '应用列表',
      authorityManagement : '权限管理',
      otaParamManagement : 'OTA参数管理',
      apppublish : '应用发布',
      appshelf : '应用上架',
      onshelf:'已上架应用',
      notonshelf:'未上架应用',
      appadd : '添加应用',
      appupdate : '应用更新',
      device : '设备管理',
      device_management : '管理',
      devicemonitor : '设备信息监控',
      fence : '电子围栏',
      drawfence : '围栏圈定',
      deviceexport : '设备批量导入',
      deviceadd : '设备添加',
      deviceedit : '设备编辑',
      functionforbidden : '功能禁用',
      configuration : '配置管理',
      appcenter : '应用中心配置',
      thirdapp : '第三方应用配置',
      notfound : '找不到页面',
      errorpage : '错误页面',
      home : '主页',
      dataCenter:'数据中心',
      deviceMap:'设备地图',
      account_manage :'商户信息管理',
      company_info : '公司信息',
      personal_info : '个人信息',
      my_operator : '我的操作员',
      children_account :'子商户',
      my_children_account :'我的子商户',
      app_market:'应用市场',
      menu_banner:'广告栏',
      menu_app_upload : '应用上传',
      menu_inside_app:'内部应用',
      menu_app_check : '应用审核',
      app_manage : '应用管理',
      app_detail : '应用详情',
      app_add : '应用详情',
      app_param_config:'参数配置',
      app_deploy:'应用部署',
      app_version_manage : '版本管理',
      app_manage_content : '管理内容',
      device_app_info:'设备应用信息',
      device_life_cycle:"设备生命周期",
      remote_assistance:'远程协助',
      device_config:'设备配置',
      my_boot_animation:'我的开机动画',
      group_manager:'分组管理',
      remote_screen:'远程桌面',
      after_sale_service:'售后服务',
      apply_after_sale:'申请售后',
      service_progress:'售后进度',
      flowManagement:'流量管理',
      flow_manage:'流量管家',
      flowLimitWarn:'限额提醒',
      visitInfoStatistic:'到访信息统计',
      abnormalAlarmStatistics:'异常告警统计',
      organization_management: '机构管理',
      manufacturer_management: '型号管理',
      manufacturer_dvc_type:'设备型号',
      device_detail:'设备详情',
      device_detail_tab:'设备详情',
      device_tabs:'设备信息',
      param_add:'新增应用参数',
      param_edit:'应用参数克隆',
      param_edit1:'应用参数编辑',
      param_view:'查看应用参数',
      organization_management_another: '机构管理',
      organization_management_repository: '机构设备仓库',
      opt: 'OTP',
      mas_list:"MAS 列表",
      policyManagement: '策略管理',
      configurationManagement: '配置管理',
      basesetting: '基础设置',
      operation_log: '操作日志',
      authority_management: '权限管理',
      platform_settings:'平台设置',
      ota: 'OTA',
      device_task:'设备任务',
      occupy_screen:'霸屏应用',
      report: '报表',
      device_conn_analysis:'设备连接分析',
      network_conn_analysis:'网络连接分析',
      device_location_change:'设备位置变化',
      alive_device_analysis:"设备活跃情况",
      paramManage: '参数管理',
      paramManage_dict: '参数字典',
      paramManage_manage: '参数管理',
      log_manage:"日志管理",
      bulk_task:"批量任务",
      export_task:"导出任务",
      deviceApp_installStatistics:'应用安装情况',
    },
    index : {
      pic1_desc1:'远程管理',
      pic1_desc2:'穿戴式企业智能终端U2',
      pic1_desc3:'企业级智能终端i6310系列',
      pic1_desc4:'企业级安全智能终端i6200S系列',
      pic2_desc1:'移动智能支付终端',
      pic2_desc2:'扫码支付盒子Q500',
      pic2_desc3:'i9100移动智能云POS',
      pic2_desc4:'移动智能支付终端i9000S',
      pic3_desc1:'移动RFID数据终端',
      pic3_desc2:'RFID超高频V5000UHF系列',
      pic3_desc3:'工业级RFID手持终端V5000S',
      pic3_desc4:'工业级RFID手持终端V5000S',
      pic4_desc1:'扫描枪与打印机',
      pic4_desc2:'K319移动打印机',
      pic4_desc3:'4寸热转印条码打印机D7000',
      pic4_desc4:'商用影像式扫描枪S750',
      pic5_desc1:'自动化立体仓库',
      pic5_desc2:'智能仓库管理系统',
      pic5_desc3:'智能多穿立体库',
      pic5_desc4:'智能堆垛机立体库',
    },
    function : {
      personal : '个人信息',
      changeavatar : '更换头像',
      changepass : '修改密码',
      logout : '退出登录',
      changePic:'更换头像',
      changePwd:'修改密码',
      version:'版本',
      return_manage:'返回母商户',
      changelanguage:'切换语言'
    },
    customer:{
      select_return_address_tip:'请选择返修点再提交',
      max_select_error:'最多选择三项',
      select_row_delete:'请选择删除行进行删除',
      company_info_mix:'公司信息未填写完整',
      return_repair_info_mix:'送修信息未填写完整',
      no_sn:'设备序列号未填写',
      select_q:'请选择故障问题',
      no_fuhao:'设备序列号末尾不能有逗号',
      no_space:'设备序列号末尾不能有空格',
      no_end_space:'设备序列号内不能存在空格',
      no_end_sn:'末尾无sn',
      sn_1_30:'设备序列号为1-30位数字或字母',
      douhao_fenge:'设备序列号使用英文逗号分开',
      step1:'填写公司信息',
      step2:'填写送修信息',
      step3:'选择返修站点',
      step4:'完成',
      company_info:'公司信息',
      company_name:'公司名称:',
      contact_person:'联系人:',
      contact_email:'联系邮箱:',
      contact_tel:'联系电话:',
      return_address:'返回地址',
      select_area:'选择地区:',
      address:'详细地址:',
      next_step:'下一步',
      last_step:'上一步',
      company_name_tip:'请输入公司名称',
      contact_person_tip:'请输入联系人',
      contact_tel_tip:'请输入联系电话',
      contact_email_tip:'请输入联系邮箱',

      address_tip:'请输入详细地址',
      express_tip1:'请输入快递公司名称',
      express_tip2:'请输入快递单号',

      select_malfunction_type:'选择故障问题',
      submit0:'提交',
      select_area_tip:'请选择省市区',
      step2_top_tip:'提示：送修设备自行取下随机配件：电池、SIM卡、内存卡（电池后盖若无腕带请一并取下）。',
      enter_back_info:'填写送修信息',
      no:'序号',
      device_sn:'设备序列号/SN',
      every_list_sn_enter_tip:'请输入送修设备SN，不同设备之间使用英文逗号分开；例：12345,12346',
      malfunction_type:'故障问题',
      select_malfunction_type_tip:'请选择故障问题',
      remark:'备注',
      enter_remark_tip:'请输入备注（选填）',
      step3_tip:'提示：送修地址，就近原则，以免耽误您的使用。',
      select_return_address:'选择返修点',
      accept:'（收）',
      submit_success:'提交成功',
      enter_express_no_quckly:'请尽快填写快递单号',
      other_tip0:'您可在售后进度查询处补充快递单号或查询受理站点信息等',
      accept_address:'受理站点',
      enter_express:'填写快递单号',
      scan_service_progress:'查看售后进度',
      express_name:'快递公司',
      express_no:'快递单号',
      please_enter_no:'请填写单号',
      email_validate_tip:'请输入联系邮箱',
      tel_validate_tip:'请输入联系电话',
      progress_search_tip:'输入SN号/快递单号',
      query0:'查询',
      device_sn_0:'设备SN号',
      apply_time:'申请日期',
      weixiu_address:'维修站点',
      detail0:'详情',
      dvc_type:'设备类型',
      return_date:'寄回日期',
      return_express_no:'返回单号',
      receiver:'收件人',
      repair_status:'维修状态',
      enter_sn_tip:'请输入SN号',
      select_express_no:'选择返回单号',
      select_status:'选择状态',
      after_sale_detail:'售后详情',
      text0:'设备还在路上，站点待签收',
      text1:'设备需要维修费用，报价单会在近期内发到您的邮箱，请注意查收',
      text2:'设备已修复，将立即寄出',
      text3:'您已确认不维修，请拨打0755-22673993要求原返',
      text4:'设备已收到，正在维修',
      text5:'设备已原返，请查收',
      text6:'设备已寄出，请查收',
      text7:'您已同意报价，未付款的请尽快安排付款',
      text8:'设备需要报价，请查看您邮箱，邮箱若是没有收到报价单，请联系0755-86520009',
      text9:'您的设备已经付款',
    },
    //配置操作记录
    rule:{
      // UTMS中不许删除**************************************************
      my_deploy_rule:'我的部署规则',
      rule_name:'名称',
      rule_version:'版本号',
      operate_user:'操作员',
      version:'版本号',
      push_circle:'查询推送范围',
      operate_time:'操作时间',
      operate:'操作',
      view_push_content:'查看推送内容',
      pushRange:'查看推送范围',
      operate_record:'操作记录',
      record_return:'返回',
      record_content:'推送内容',
      record_modal_close:'关闭',
      app_deploy:'应用部署',
      unfinish_sn:'未完成SN号',
      unfinish_title:'完成状态',
      sn:'SN',
      dvc_org:'设备所属机构',
      schedule:'完成度',
      sn_own_group:'设备所属分组',
      has_push_group:'机构名称',
      has_push_status:'已推送',
      will_push_status:'未推送',
      // UTMS中不许删除**************************************************

    },
    form : {
      play:'播放',
      finish_time0_1:'结束时间',
      record_time:'记录时间',
      restore_record_remark:'设备离开地理围栏达到时长后，将恢复出厂设置',
      restore_record_remark_front:'设备离开地理围栏',
      restore_record_remark1:'禁用设备',
      restore_record_remark2:'禁用移动网络',

      record_warn:'警告',
      enter_limit_time_chaochu:'最大限定时长为7天',
      enter_limit_time_error:'请输入正整数',
      enter_limit_time:'请输入限制时长',
      select_time_danwei:'请选择时间单位',
      limit_minute:'分',
      limit_hour:'小时',
      restore_tip:'提醒',
      tip_of_restore_device_data:'设备离开地理围栏达到指定的时间后，恢复出厂设置',
      limit_time:'限定时长',
      save_success:'保存成功',
      app_deploy_manage:'应用部署',
      app_deploy_manage_detail:'查看应用部署',
      app_white_list:'应用白名单',
      app_survival_list:'应用保活名单',
      app_black_list:'应用黑名单',
      to_deploy_app:'部署应用',
      tree_empty:'暂无数据',
      deploy_push_manage:'推送管理',
      deploy_name:'配置名称',
      deploy_type:'类型',
      deploy_version:'版本',
      deploy_push_circle:'推送范围',
      deploy_status:'推送状态',
      deploy_schedule:'执行进度',
      deploy_schedule_tips:"未完成/已完成/执行失败+终止操作/总设备数",
      deploy_operate:'操作',
      deploy_add:'添加',
      deploy_name_not_empty:'配置名称不能为空',
      deploy_type_not_empty:'请选择部署方式',
      deploy_operation_success:'操作成功',
      deploy_time_not_empty:'请选择部署时间',
      deploy_enable_uninstall_empty:'请选择是否允许卸载',
      default_app_deploy_name:'我的应用配置',
      deploy_must_input:'必填',
      deploy_must_select:'必选',
      deploy_delete:'删除',
      deploy_install_mode0:'静默安装',
      deploy_install_mode1:'下载后通知用户安装',
      deploy_select_app:'应用选择',
      deploy_current:'立即部署',
      deploy_select:'选择部署时间',
      deploy_select_time:'选择时间',
      deploy_app_mode:'部署方式',
      deploy_app_interval:'部署时间',
      deploy_app_uninstall:'允许卸载',
      deploy_app_uninstall_true:'是',
      deploy_app_uninstall_false:'否',
      deploy_app_push:'推送',
      deploy_app_edit:'编辑',
      deploy_app_edit_modal:'应用部署编辑',
      deploy_record:'记录',
      deploy_delete_rule:'确定要删除部署规则?',
      deploy_check_rule:'您已创建一条应用相同，版本相同的规则，请问是否继续?',
      deploy_delete_tip:'提示',
      deploy_unfinish_sn:'未完成SN：',
      deploy_update_app_tip1:'应用',
      deploy_update_app_tip2:'已更新至',
      deploy_update_app_tip3:'是否推送更新到最新版本？',
      noneDvcType:'未找到需要设置的设备类型',
      custom_desk_add:'自定义桌面添加',
      deskAttention: '注意: 自定义桌面将在设备启动或重启时检查并下载，如果您的用户使用SIM进行连网操作，请注意桌面下载所带来的流量消耗。',
      getDeskDetailFailed:'获取桌面详情失败',
      deskSelectFailed:'桌面选择失败',
      deskSelectSuccess:'桌面选择成功',
      deskUsingNow: '该桌面正在使用中',
      btnUse: '使用',
      explanation : '说明',
      selected: '选中',
      deskDetail:'桌面详情',
      sysDefaultDesk:'系统桌面(默认)',
      clear_oprate : '清除锁屏密码',
      recover_operate :'恢复出厂设置',
      last_use_time : '最后一次使用时间',
      last_use_address : '最后一次使用位置',
      clp_tip : '清除密码后不会导致应用数据丢失，但密码将无法恢复，是否继续？',
      recover_tip : '恢复出厂设置后，设备将还原最原始的状态，是否继续？',
      usage_operator : '操作人',
      remark :'备注',
      task_progress : '任务进度',
      device_group_name : '设备组名称',
      device_set_wifi:'WiFi配置',
      device_get_log:'设备日志',
      clear_password : '清除密码',
      usage_recover : '恢复出厂设置',
      usage_restart : '重启',
      usage_shotdown : '关机',
      usage_file_send : '文件分发',
      usage_uninstall_app :'卸载应用',
      usage_end_time : '结束时间',
      usage_start_time : '开始时间',
      usage_ope_type_select : '操作类型选择',
      usage_sn_query : '输入SN查询',
      app_grayscale_view:'查看灰度范围',
      app_grayscale_nosn:'暂无灰度范围设备',
      app_grayscale_change:'调整灰度范围',
      app_grayscale_clearall:'清除全部',
      app_grayscale_tip1:'请选择设备后再确认',
      app_grayscale_tip2:'没有符合条件的设备',
      app_grayscale_confirm:'确定',
      app_delete_all:'您将删除此应用，是否确定删除？',
      app_banner_url_max:'链接最大长度为500个字符 http://',
      app_publish_sn_cancel : '数据未保存，是否离开？',
      app_upgrade : '应用更新',
      app_set_gray_range:'设置灰度范围',
      app_upgrade_note : '升级说明',
      ajust_gray_deploy : '调整灰度',
      app_all_deploy : '全部部署',
      app_gray_upgrade : '灰度升级',
      app_remarket : '备注:',
      app_upload_desPicture : '描述图片',
      app_deploy : '部署:',
      upgrade_curr_total : '已更新台数',
      app_publish_time : '发布日期',
      app_version_code : '版本编号',
      app_version_note : '版本说明',
      normal_upgrade : '正常升级',
      coverage_upgrade : '覆盖升级',
      to_formal_edition : '转为正式版',
      restore_issue : '恢复发行',
      pause_issue : '暂停发行',
      gray_packge : '灰度包',
      formal_package : '正式包',
      app_review_ing : '审核中',
      app_review_yes: '审核成功',
      app_review_no: '审核失败',
      app_publish_no : '未上架',
      app_publish_yes : '已上架',
      full_channel : '全渠道',
      curr_channel : '本渠道',
      app_publish_channel_way : '发布应用渠道',
      app_publish_status : '上架状态',
      app_desc_pic_upload:'上传描述图片:',
      app_desc_pic_checkout:'(上传格式PNG/JPG，大小不超过5M)',
      app_apk_upload:'点击或拖拽安装包到此处上传',
      app_add_device:'添加SN',
      device_search_tip : '输入关键字搜索',
      device_distribute_batchBind:'批量绑定',
      device_distribute_batchUnbind:'批量解绑',
      device_distribute_selectSubAccount:'请选择子商户',
      no_match:'无匹配数据',
      device_distribute_enterSn:'请输入SN号',
      device_distribute_enterSn2:'请输入SN号查询',
      device_distribute_add:'添加',
      device_distribute_download:'下载模板',
      device_distribute_batchImport:'批量导入',
      device_distribute_dragTip:'拖拽表格或点击此处，直接导入',
      device_distribute_totalNum:'总计',
      device_distribute_unbindNum:'未绑定',
      device_distribute_unexistNum:'不存在',
      device_distribute_isFreezeNum:'冻结中',
      device_distribute_repeatNum:'无效重复',
      device_distribute_not_bind:'未绑定',
      device_group_grouped:'已分组',
      device_group_unGrouped:'未分组',
      device_distribute_cancel:'取消',
      device_distribute_confirmBind:'确定绑定',
      device_distribute_confirm:'确定',
      device_distribute_serialNum:'序号',
      device_distribute_errorRow:'出错行数',
      device_distribute_di:'第',
      device_distribute_row:'行',
      device_distribute_errorReason:'出错原因',
      device_distribute_devType:'机型',
      device_jd_type:'机型',
      device_group_code:'分组名称',
      device_distribute_subAccount:'子商户',
      device_distribute_status:'状态',
      device_distribute_tip1:'请导入需要绑定的设备编号',
      device_distribute_tip2:'没有符合条件的待绑定设备',
      device_distribute_tip3:'没有符合条件的可赠送设备',
      device_distribute_tip4:'没有符合条件的待关联设备',
      device_donaterecord_unFinished:'未完成',
      device_donaterecord_searchTip:'输入SN号查询',
      device_donaterecord_startTime:'开始时间',
      device_donaterecord_endTime:'结束时间',
      device_donaterecord_donateType:'类型',
      device_donaterecord_all:'全部',
      device_donaterecord_search:'查询',
      device_donaterecord_finished:'已完成',
      device_donaterecord_result:'结果',
      device_donaterecord_snNo:'SN号',
      device_donaterecord_operateTime:'操作时间',
      device_donaterecord_alreadyReject:'已拒绝接收',
      device_donaterecord_alreadyRecept:'已成功接收',
      device_donaterecord_alreadyRevoke:'已撤销赠送',
      device_donaterecord_unknown:'未知',
      device_donaterecord_accept:'接受',
      device_donaterecord_donate:'赠送',
      device_donaterecord_revoke:'撤销赠送',
      device_donaterecord_acceptDonate:'成功接收',
      device_donaterecord_refuseDonate:'拒绝接收',
      device_donaterecord_partnerAcceptDonate:'对方接收',
      device_donaterecord_partnerRefuseDonate:'对方拒绝',
      device_donaterecord_donateTime:'赠送发起时间',
      device_donaterecord_dateTimeTip1:'请选择开始时间',
      device_donaterecord_dateTimeTip2:'请选择结束时间',
      device_donaterecord_dateTimeTip3:'开始时间大于结束时间，请重新选择',
      device_donaterecord_dateTimeTip4:'时间间隔不能大于30天',
      device_donaterecord_revoke2:'撤销',
      device_donaterecord_confirmRevokeTip:'确认撤销赠送这台设备，是否继续？',
      device_donaterecord_confirmReceptTip:'确认接收这台设备，是否继续？',
      device_donaterecord_confirmRejectTip:'确认拒绝这台设备，是否继续？',
      device_donaterecord_reject:'拒绝',
      device_donate_batchDonate:'批量赠送',
      device_donate_enterTip1:'请输入公司ID',
      device_donate_enableDonateNum:'可赠送',
      device_donate_receiver:'接收方',
      device_donate_receiverTip1:'请输入公司ID',
      device_donate_tip1:'设备赠送被对方接收后将不可撤回，请确认好接收方后再赠送',
      device_donate_confirm:'确认赠送',
      device_donate_checkCompanyInfo:'核实接收方信息',
      device_donate_companyName:'接收方名称',
      device_distribute_freeze:'设备冻结中',
      device_distribute_skip_level:'设备为跨级子账户',

      device_group_check_tip1_no:'请先选中分组，再进行该操作',
      device_group_checked_tip_no:'请勾选一个设备组',
      device_group_checked_tip:'最多勾选一个设备组',
      device_group_multiple_tip:'不能移动到同一设备组',
      device_group_move_tip:'将本组的设备全部移动到所选组下',
      device_group_enter_groupName:'请输入分组名（必填）',
      device_group_enter_groupName_tip:'请输入分组名！',
      device_group_enter_locationInfo:'请输入位置信息（选填）',
      device_group_enter_name:'请输入姓名（选填）',
      device_group_enter_contacts:'邮箱/电话（选填）',
      device_group_enter_remarks:'备注（选填）',
      device_group_administrator:'管理员',
      device_group_administratorName:'管理员姓名',
      device_group_contacts:'联系方式',
      device_group_tools_details:'直属终端和子分组终端数总和',
      device_group_deviceCount:'终端数',
      device_group_deviceTotalCount:'终端总数',
      device_group_address:'位置信息',
      device_group_quCode:'分组二维码',
      device_group_quCodeDetail:'通过设备端“应用市场”-“设置”-“扫一扫”功能，可直接扫码进入此分组',
      device_group_associateDevice:'关联设备',
      device_group_associateDevice2:'关联终端',
      device_group_exportDevice:'导入终端',
      device_group_deviceMove:'设备移动到',
      device_group_batchManage:'批量管理',
      device_import_notes:'导入备注',
      device_group_importGroup:'导入组',
      device_group_exportGroup:'导出组',
      device_group_name2:'分组名称',
      device_group_allDevice:'全部设备',
      device_group_all_group:'全部分组',
      device_group_add:'添加设备组',
      device_group_tip1:'请输入设备组名称',
      device_group_update:'修改设备组名称',
      device_group_confirm:'确认',
      device_group_tip2:'请输入设备组名称后再确认',
      device_group_total:'总设备数：',
      device_group_online_total:'在线设备数：',
      device_groupDevice_alreadySelect:'已选',
      device_groupDevice_tip1:'台',
      device_groupDevice_batchOper:'批量操作',
      device_groupDevice_disable:'设备禁用',
      device_groupDevice_undisable:'设备解禁',
      device_groupDevice_moveto:'移动到',
      device_groupDevice_uninstallApp:'卸载应用 一次仅可卸载一个应用',
      device_groupDevice_fileDistribution:'文件分发',
      device_groupDevice_extractDeviceLogs:'提取设备日志',
      device_groupDevice_scanLogs:'查看日志',
      device_groupDevice_wifiSetting:'WiFi配置',
      device_groupDevice_shutDown:'关机',
      device_groupDevice_restart:'重启',
      device_groupDevice_ring:'设备响铃',
      device_groupDevice_extract_dvc_logs:'提取设备日志',
      device_groupDevice_wifi_conf:'WiFi配置',
      device_groupDevice_operate:'操作',
      device_groupDevice_number:'数量',
      device_groupDevice_progress:'进度',
      device_groupDevice_detail:'详情',
      device_groupDevice_confirm2:'确定',
      device_groupDevice_confirm3:'编辑',
      device_groupDevice_wifiSetting_tip:'WiFi远程配置',
      device_groupDevice_apnSetting_tip:'APN设置添加',
      device_groupDevice_view_apnSetting_tip:'查看APN内容',
      device_groupDevice_edit_apnSetting_tip:'APN设置编辑',
      device_groupDevice_tip2:'一次仅可卸载一个应用',
      device_groupDevice_uninstallType:'卸载方式：',
      device_groupDevice_appPackageName:'应用包名：',
      device_groupDevice_configName:'配置名称：',
      device_groupDevice_tip3:'填写要卸载的应用包名，仅限一个（例如：ffsdsssd.dasdasd.sadasd）',
      device_groupDevice_tip4:'请确认包名的准确性',
      device_groupDevice_configName_input:'请填写配置名称',
      device_groupDevice_appName:'应用名称：',
      device_groupDevice_tip5:'请选择应用名称',
      device_groupDevice_config_version:'版本号：',
      device_groupDevice_version:'应用版本：',
      device_groupDevice_tip6:'请选择应用版本',
      device_groupDevice_cancel:'取消',
      device_groupDevice_next:'下一步',
      device_groupDevice_tip7:'一次仅可分发一个文件',
      device_groupDevice_fileUpload:'文件上传：',
      device_groupDevice_uploadFile:'上传文件',
      device_groupDevice_tip8:'文件大小不超过100M,文件分发后不可撤回,请慎重!',
      device_groupDevice_targetPath:'目标路径：',
      device_groupDevice_tip9:'格式如：/sdcard/MDM',
      device_groupDevice_tip10:'如上为设备端文件存储的指定路径!',
      device_groupDevice_fileRule:'文件规则：',
      device_groupDevice_deviceGroup:'设备分组',
      device_groupDevice_uninstallAppTip:'后 【卸载应用】 任务到期',
      device_groupDevice_uninstallAppName:'卸载应用名称：',
      device_groupDevice_uninstallAppPackageName:'卸载包名：',
      device_groupDevice_tip11:'输入SN号查询',
      device_groupDevice_refresh:'刷新',
      device_groupDevice_revoke:'撤销',
      device_groupDevice_shutDownTip:'后 【关机】 任务到期',
      device_groupDevice_retry:'重试',
      device_groupDevice_restartTip:'后 【重启】 任务到期',
      device_groupDevice_fileDistributionTip:'后 【文件分发】 任务到期',
      device_groupDevice_wifiSettingTip:'后 【WiFi配置】 任务到期',
      device_groupDevice_extractDvcLogsTip:'后 【提取设备日志】 任务到期',
      device_groupDevice_fileName:'文件名：',
      device_groupDevice_fileSize:'文件大小：',
      device_groupDevice_isCoverYes:'是否覆盖：是',
      device_groupDevice_isCoverNo:'是否覆盖：否',
      device_groupDevice_isRemindYes:'是否提示对方：是',
      device_groupDevice_isRemindNo:'是否提示对方：否',
      device_groupDevice_uninstallType1:'按应用名卸载',
      device_groupDevice_uninstallType2:'按包名卸载',
      device_groupDevice_deviceStatus:'状态',
      device_groupDevice_deviceZhuangTai:'设备状态',
      device_groupDevice_deviceStatus1:'在线',
      device_groupDevice_deviceStatus2:'离线',
      device_groupDevice_deviceType:'机型',
      device_groupDevice_deviceRemarks:'备注',
      device_groupDevice_deviceLocation:'位置信息',
      device_groupDevice_deviceNetwork:'网络',
      device_groupDevice_deviceBattery:'电量',
      device_groupDevice_deviceBanStatus:'权限',
      device_groupDevice_deviceXingHao:'设备型号',
      device_groupDevice_dvcId:'SN号',
      device_groupDevice_dvcSn:'设备SN号',
      device_groupDevice_lastRequestTime:'上次连入时间',
      device_groupDevice_coverOriginal:'覆盖原有文件',
      device_groupDevice_tip12:'下载成功后提示对方',
      device_groupDevice_executing:'执行中',
      device_groupDevice_executeSuc:'执行成功',
      device_groupDevice_executeFail:'执行失败',
      device_groupDevice_groupName:'分组路径',
      device_groupDevice_time:'时间',
      device_groupDevice_executing2:'待执行',
      device_groupDevice_tip13:'请输入SN号',
      device_groupDevice_tip14:'没有该设备的记录',
      device_groupDevice_tip15:'请上传需要分发的文件!',
      device_groupDevice_tip16:'请输入正确的目标路径!',
      device_groupDevice_tip17:'请输入要卸载的应用包名',
      device_groupDevice_tip18:'请选择要卸载的应用名称',
      device_groupDevice_tip19:'请选择要卸载的应用版本',
      device_groupDevice_ssid_tip:'请输入服务集标识符（SSID）',
      device_groupDevice_operate_tip:'请选择操作类型',
      device_groupDevice_group_tip:'请勾选设备组',
      device_groupDevice_banStatus_normal:'正常',
      device_groupDevice_banStatus_prohibited:'禁用',
      device_groupDevice_banStatus_prohibited_msg:'您可以输入禁用提示语，最长150个字符',

      device_remote_wifiSetting_ssid:'服务集标识符（SSID）',
      device_remote_wifiSetting_ssid_allow:'只允许连接该SSID',
      device_remote_wifiSetting_ssid_allow_tip:'只允许连接该SSID下发设备终端',
      device_remote_wifiSetting_ssid_tip:'要连接的WiFi名称',
      device_remote_wifiSetting_hide:'隐藏网络',
      device_remote_wifiSetting_hide_tip:'目标网络非开放网络或未广播信号时，请开启此功能',
      device_remote_wifiSetting_autoJoin:'自动加入',
      device_remote_wifiSetting_autoJoin_tip:'自动加入此无线网络',
      device_remote_wifiSetting_safeType:'安全类型',
      device_remote_wifiSetting_safeType_tip:'连接时使用的无线网络加密类型',
      device_remote_wifiSetting_pwd:'密码',
      device_remote_wifiSetting_pwd_tip:'无线网络密码',

      //  功能设置
      device_groupDevice_FunctionSetting_tip:'功能设置添加',
      device_groupDevice_FunctionSetting_edit_tip:'功能设置修改',
      device_remote_rule_name:"规则名称",
      device_remote_fcSetting_bluetooth_disable: "禁用蓝牙",
      device_remote_fcSetting_wifi_disable: "禁用WIFI",
      device_remote_fcSetting_allow_uninstall:'允许卸载',
      device_remote_fcSetting_allow_permission:'允许应用权限',
      device_remote_fcSetting_gms_disable:"禁用GMS",
      device_remote_fcSetting_nfc_permission:'禁用NFC',
      device_remote_fcSetting_camera_permission:'禁用相机',
      device_remote_fcSetting_MobileTraffic_disable: "禁用移动流量",
      device_remote_fcSetting_ThirdPartyApplicationInstallation_disable: "禁用第三方应用安装",
      device_remote_fcSetting_camera_disable: "禁用相机",
      device_remote_fcSetting_tel_disable: "禁用电话",
      device_remote_fcSetting_message_disable: "禁用短信",
      device_remote_fcSetting_gps_disable: "禁用GPS",
      device_remote_fcSetting_adb_disable: "禁用ADB",
      device_remote_fcSetting_usb_disable: "禁用USB",
      device_remote_fcSetting_home_disable: "禁用Home键",
      device_remote_fcSetting_dropDown_disable: "禁用下拉状态栏",
      device_remote_fcSetting_input_disable: "禁用输入法弹出",
      device_remote_fcSetting_restoreFactory_disable: "禁用恢复出厂设置",
      device_remote_fcSetting_sd_disable: "禁用SD卡",
      function_setting_push:'功能设置推送',

      function_ruleName:"规则名称不能为空",

      myFunctionSetting:'我的功能设置',
      myWifiSetting:'我的WIFI设置',
      wifiNameNotSame:"WIFI设置名称不可重复",
      customDeskNameNotSame:'配置名称不可重复',

      function_pushRange:"推送范围不能为空",
      function_push_confirm:"确认推送以下范围？",
      function_push_histroy_content:"功能设置历史推送内容",
      delete_function_config_batch:'删除功能设置配置',
      delete_function_config_batch_tip:'删除功能设置配置，设备端配置信息也随之删除，设备恢复原始设置，是否删除？',
      on:'开启',
      off:'禁用',


      close:'关闭',
      open:'打开',
      companyName:'公司名称',
      companyAddress:'公司地址',
      companyShortName:'公司简称',
      companyWebsite:'公司网址',
      countryCode:'国家/地区',
      companyPrincipal:'公司联系人',
      companyArea:'公司区域',
      companyEmail:'公司邮箱',
      companyCredential:'身份证/营业执照',
      companyTel:'联系电话',

      company_name_rule:'请输入公司名称',


      default :'默认策略',
      app_packagename_tip:'以输入包名为准',
      delete_success : '删除成功',
      username : '账号',
      nickname : '姓名',
      password : '密码',
      default_password : '默认密码为908070',
      defpass : '默认密码为One@908070',
      email : '邮箱',
      tel : '联系方式',
      sex : '性别',
      type : '类型',
      type_all : '所有',
      type_platform : '平台用户',
      type_pda : '终端用户',
      sexfemale : '女',
      sexmale : '男',
      job : '岗位',
      description : '描述',
      lastupdatetime : '上次编辑时间',
      lastupdateuser:'上次编辑的操作员',
      submit : '确认',
      reset : '重置',
      return : '返回',
      avatar:'头像',
      saveupdate:'保存修改',
      avatarupload : '头像上传',
      avatarchange : '更换头像',
      oldpassword : '当前密码',
      newpassword : '设置新密码',
      pleaseinputnewpassword:'请输入新密码',
      newpasswordtip : '新密码--更新之后需要重新登录！',
      confirmnewpassword : '重复新密码',
      organizationname : '机构名称',
      uploadNode:'上传机构名',
      organization_1 : '机构',
      selectorganization : '请选择机构',
      selectOrgTip:'最底层无法添加机构',
      user_search_tip : '账号/姓名/机构名称',
      user_chirld_account:'请输入子商户名',
      search : '搜索',
      addPlatformUser : '添加用户',//'新增平台用户',
      addPDAUser : '新增终端用户',
      editUser : '编辑用户',
      batchdel : '批量删除',
      batchdel_confim : '删除确认',
      reminder :'温馨提示',
      lockTip0:'将锁定应用：',
      // lockTip1:'，此设备类型下的已锁定应用将会解锁，是否继续？',
      lockTip1:'，锁定后应用将无法退出，需通过霸屏解锁密码才能退出，是否继续？',

      fourPwd:'请输入4位有效数字',
      unlockTip0:'将解锁应用：',
      unlockTip1:'，是否继续？',
      removeOccupyApp0:'将从',
      removeOccupyApp1:'中移除',
      removeOccupyApp2:'，是否继续？',
      batchdel_confim_tip : '确认删除这些用户，是否继续？',
      batchdelone_confim_tip : '确认删除该用户，是否继续？',
      batchlogout_confim_tip : '确认退出登录，是否继续？',
      batchh_return_parent_account_tip:'确认返回母商户，是否继续？',
      device_binding:'绑定',
      device_unBingding:'解绑',
      device_change_subaccount:'更换子商户',
      device_binding_subaccount:'绑定子商户',
      resetpass : '重置密码',
      editpass:'修改密码',
      updatepass : '更新密码',
      confirmresetpass_tip :'此操作将重置密码,重置密码为One@908070',
      continue : '是否继续？',
      status : '状态',
      status_normal : '正常',
      status_deleted : '已删除',
      status_locking : '锁定中',
      operation : '操作',
      wait_operate:'待执行',
      operate_success:'执行成功',
      operate_fail:'执行失败',
      subordinate_account : '所属商户',
      children_account:'子账户',
      nooperation : '无操作项',
      noauthtips:'超级管理员，无权限操作',
      nooperationtips:'当前登录用户，不可操作',
      selectmoreone : '请至少选择一项',
      selectgroup : '请勾选分组',
      selectone: '请选择一项应用',
      deleteDisabledMDM:'不可删除MDM应用',
      outofauthority:'为权限外设备，请重新选择',
      alreadyDisabled:'已经为禁用状态，请重新选择',
      noNeedUnforbidden:'无需解禁，请重新选择',
      noOrderRight:'不能执行该指令，请重新选择',
      alreadyBelongOrg:'已经属于当前选择机构',
      occupyScreenForPdaToptips:'因霸屏状态下导航栏没有返回键，请尽量保证被设置的应用有返回功能和退出功能；锁定后，终端设备将无法修改已设置的霸屏应用',
      setOccupyScreenModel:'设置为霸屏模式',
      setSilentAppModel:'设置为默启',
      silent_query_appname:'请输入应用名称',
      edit : '编辑',
      update : '更新',
      lock : '锁定',
      passwordEdit : '修改密码',
      restoration:'恢复正常状态',
      passedit:'密码修改',
      pleaseSelectnode:'请选择机构',
      batchlock_confim : '锁定确认',
      batchlock_confim_tip : '此操作将锁定用户',
      unlock : '解除锁定',
      delete : '删除',
      recovery : '恢复',
      batchrecovery_confim : '恢复确认',
      batchrecovery_confim_tip : '确认恢复用户到正常状态，是否继续？',
      id : '编号',
      lastloginip: '上次登录ip',
      lastlogintime: '上次登录时间',
      role : '角色',
      role_p : '角色权限',
      auth:'权限',
      add : '新增',
      addOrg:'新增机构',
      organizationid : '机构编号',
      organizationalias : '机构简称',
      organizationadmin : '机构管理员',
      organizationadmin_tips:'当前机构超级管理员,密码为One@908070,随机构同步新增!',
      organizationprincipal : '机构联系人',
      organizationdescription : '机构描述',
      organizationaddress : '机构地址',
      administratorNum:'管理员数',
      deviceNum:'设备数量',
      addDeviceByQR:'二维码设备添加',
      strategyInfo:'策略详情',
      QR_adddevice:'二维码添加设备',
      QR_tip:'终端设备扫描此二维码，可自行绑定设备',
      QR_download:'二维码下载',
      visableApplication:'可见应用',
      lookVisableApplication:'查看可见应用',
      deviceStrategy:'设备策略',
      configStrategy:'配置策略',
      fenceStrategy:'围栏策略',
      defaultStrategy:'默认策略',
      otherStrategy:'其他策略',
      strategyOwnOrg:'策略所属机构',
      noPublishOrg:'暂无分配机构',
      noApply:'暂无应用',
      publishStrategy:'分配',
      noStrategy:'默认策略',
      inoperatable:'对不起，您没有权限操作此机构！',
      editDisable:'提示，该策略在您权限操作范围外，限制功能不可编辑！',
      editDisable2:'提示，默认策略功能限制不可编辑！',
      confimorganizationdelete : '请确认该机构下所有数据已被清除, 是否继续删除?',
      tip : '提示',
      warmTip:'温馨提示',
      btnsave : '保存',
      btnsubmit : '确定',
      submitAppWhite:'确定',
      btncancel : '取消',
      btnreset : '重置',
      checkall:'全选',
      checkallDvc:'所有设备类型',
      deviceTip: '设备类型发布：发布至分组下相同设备类型',
      groupPush: '分组发布',
      groupPushTip: '分组发布：发布至分组内的所有设备或者指定设备类型',
      SnPush: 'SN发布',
      SnPushTip: 'SN发布：仅对输入SN的设备发布',
      btnPush: '发布',
      childRe:'关联子分组',
      parent : '父级',
      deviceMoveToOrg:'所属机构',
      occupyScreenPwdTip:'当前霸屏解锁密码（4位数字）',
      appname : '应用名称',
      appurl : '应用下载地址',
      applogo : '应用图标',
      appIcon : '应用Icon',
      appIconCheckout:'(大小：不大于100KB,图片格式：PNG/JPG)',
      appIconCheckout_size:'大小：不大于100KB',
      appIconCheckout_pix:'尺寸：140*140像素',
      appIconCheckout_format:'格式：PNG/JPG/JPEG',
      appDesc:"应用简介",
      descriptionhint2:'请填写应用简介',
      bussType:"行业分类",
      apppackage : '包名',
      appversion:'版本',
      pubDitch:'发布渠道',
      allDitch:"全渠道",
      selfDitch:"本渠道",
      deployType:"部署方式",
      settings2:'设置项',
      allDeploy:"全部部署",
      grayDeploy:"灰度部署",
      appversioncount:'版本数量',
      device_sn : '设备SN号',

      groupshelf1:'分组上架',
      groupshelf:'分组上架',
      shelfrevise:'上架调整',
      appforce : '自动安装',
      appsize : '大小',
      ShelfDvcType:'上架机型',
      versionState:'版本说明',
      appDescPic:'产品截图',
      appversioncode : '版本号',
      appversionname : '版本名',
      appDownloadNum:'下载量',
      appid : '应用编号',
      applanguage : '语言',
      appfeature : '更新信息',
      appnamehint : '请输入1-20个字符',
      descriptionhint : '请输入0-300个字符',
      appfeaturehint : '请输入0-200个字符',
      appproducerhint:'请输入0-50个字符',
      appproducer: '厂商',
      appdescmaxlength : '请输入不超过1000个字符!',
      appproducerLength : '请输入不超过100个字符!',
      uploadtime : '上传时间',
      updatetime : '更新时间',
      uploaduser : '上传用户',
      updateuser : '更新用户',
      distributionorganization: '分发机构',
      distributiondev:'分发设备',
      app_search_tip : '@:yd.form.appname',
      keyword_for_search:'输入关键字搜索',
      appversionlist : '应用版本列表',
      viewallappversion : '查看所有版本',
      viewall:'查看',
      grant:"分发",
      appgrant:"发布应用",
      regrant:"重发",
      regrant2:"重新发布",
      yes: '是',
      no : '否',
      synchronous:'同步',
      unsynchronous:'不同步',
      confirmappdelete : '此操作将会移除该应用, 是否继续?',
      confirmdeleteappfromdevice : '是否同步删除设备上的应用?',
      confirmdeleteappfromdevice2 : '该操作会删除终端应用数据，是否确定删除?',
      upperapp : '上层应用',
      shelf : '上架',
      unshelf : '下架',
      appshelf : '应用上架',
      appunshelf : '应用下架',
      uploadapk : '上传APK',
      editbaseinfo : '编辑基本信息',
      selectype:'选择类型',
      confirmupload : '确认上传',
      uploadapk_tip : '点击上传安装包',
      uploadapk_tip2 : '拖拽安装包到此处上传',
      uploadapk_upload1 : '准备上传: ',
      uploadapk_upload2 : '上传中: ',
      uploadapk_has_upload : '已上传文件: ',
      chinese : '中文',
      english : '英文',
      scope : '范围',
      public : '公有',
      private : '私有',
      next : '下一步',
      previous : '上一步',
      finish : '完成',
      publish : '发布',
      canpublish : '可发布应用',
      haspublished : '已发布应用',
      notpublished : '未发布应用',
      appversionlower : '应用版本过低',
      confirmappshelf_tip : '此操作将会推送应用到设备, 是否继续?',
      confirmappunshelf_tip : '此操作将会从设备上移除该应用, 是否继续?',
      content : '消息内容',
      msg_title : '消息标题',
      owner : '所属人',
      strategy_data_send:'数据上报',
      strategy_function_limit:'功能限制',
      strategy_call_limit:'通话限制',
      strategy_app_blacklist:'应用黑名单',
      strategy_app_nessary:'必装应用与更新',
      strategy_safeDesk:'安全桌面',
      strategy_hideIcon:'隐藏APP图标',
      strategy_geo_fence:'地理围栏',
      strategy_wifi_config:'WiFi远程配置',
      strategy_wifi_control:'WiFi远程控制',
      strategy_wifi_blacklist:'WiFi黑名单',
      strategy_voice_limit:'音量控制',
      strategy_limit_tip:'以下限制功能只有在设备os版本满足安卓5.1版本才能生效',
      strategy_hotspot:'移动热点',
      strategy_usb_debug:'USB调试',
      strategy_app_install:'应用安装',
      strategy_call_blacklist:'电话黑名单',
      strategy_open_callService:'远程开启电话服务',
      strategy_close_callService:'远程关闭电话服务',
      strategy_blacklist_tip:'黑名单提示',
      strategy_window_blacklist_tip:'设备是否弹出提示禁用黑名单电话窗口',
      strategy_window_blacklist_tip2:'设备是否弹出提示禁用黑名单应用窗口',
      strategy_prompt_yes:'提示',
      strategy_prompt_no:'不提示',
      strategy_use_yes:'使用',
      strategy_use_no:'不使用',
      telephone_enter_tip:'请输入电话号码',
      strategy_add_appblacklist:'添加黑名单应用',
      strategy_enter_packageName:'包名长度1-60位，由数字、字母、下划线和.组成',
      strategy_enter_appName:'应用名称长度1-20位',
      strategy_necessary_app:'必装应用',
      strategy_necessary_tip:'必装应用不可卸载',
      strategy_necessary_tip2:'应用安装情况反馈',
      strategy_necessary_tip3:'OTA自动升级',
      strategy_necessary_tip4:'必装应用提示',
      strategy_necessary_tip5:'设备是否弹出提示必装应用窗口',
      strategy_add_necessary:'添加必装应用',
      strategy_safedesk_app:'安全桌面应用列表',
      strategy_safedesk_tip:'安全桌面',
      strategy_safedesk_tip2:'设备是否使用安全桌面',
      strategy_add_safedesk:'添加安全桌面应用',
      strategy_hideIcon_app:'隐藏图标应用列表',
      strategy_hideIcon_tip:'隐藏图标应用提示',
      strategy_hideIcon_tip2:'设备是否弹出提示隐藏图标应用窗口',
      strategy_add_hideIcon:'添加隐藏图标应用',
      strategy_fence_range:'围栏范围',
      strategy_fence_switch:'围栏开关',
      strategy_device_limit:'设备限制',
      strategy_ssid:'服务集标识符（SSID）',
      strategy_config_tip1:'要连接的无线网络标识',
      strategy_hidewifi:'隐藏网络',
      strategy_config_tip2:'目标网络非开发网络或未广播信号时 ，请开启此功能',
      strategy_config_autoIn:'自动加入',
      strategy_config_tip3:'自动加入此无线网络',
      strategy_config_safeType:'安全类型',
      strategy_config_tip4:'连接时使用的无线网络加密类型',
      strategy_config_password:'密码',
      strategy_config_password_wifi:'无线网络的密码',
      strategy_wifi_tip:'设备是否弹出提示禁用黑名单WiFi窗口',
      strategy_add_wifiblacklist:'添加黑名单WiFi',
      strategy_wifi_enter:'请输入WiFi名',
      strategy_voice_control:'设备音量控制',
      strategy_unEdit_default:'提示，默认策略功能限制不可编辑！',
      strategy_unEdit_unAuth:'提示，该策略在您权限操作范围外，限制功能不可编辑！',

      strategy_set : "策略设置",
      strategy_geo : '地理位置',
      strategy_call_time : '通话时间',
      strategy_operator : '运营商信息',
      strategy_app : '应用程序',
      strategy_battery : '电量信息',
      strategy_data_flow : '数据流量',
      strategy_mobile_data : '移动数据',
      strategy_imei : 'IMEI',
      strategy_imsi : 'IMSI',
      strategy_memory:'存储用量',
      strategy_fence_set : '设置围栏范围',
      strategy_fence_find :'查看围栏范围',
      strategy_lng : '围栏经度',
      strategy_lat : '围栏纬度',
      strategy_radius : '围栏半径',
      strategy_limit_device : '设备',
      bluetooth : '蓝牙',
      restore_device_data: '定时恢复出厂数据',
      camera : '相机',
      homekey : 'home键',
      stateBar : '下拉状态栏',
      strategy_app_config : '应用中心属性设置',
      strategy_app_password : '维护管理密码',
      strategy_app_request : '请求频率',
      strategy_time_minutes : '分钟',
      strategy_topic : '主题',
      strategy_common_area : '常用功能区',
      strategy_common_function : '收银台区',
      strategy_show : '显示',
      strategy_hide : '隐藏',
      strategy_add : '新增策略',
      strategy_delete_confirm : '策略删除确认',
      strategy_delete_confirm1: "是否删除名称为（{0}）的策略?",
      strategy_choose_confirm : '发布策略确认',
      strategy_choose_confirm1 : '是否发布名称为（{0}）的策略?',
      strategy_delete : '删除',
      strategy_choose: '应用策略',
      strategy_copy : '复制',
      strategy_choosed : '（已应用）',
      strategy_no_data : '没有数据',
      strategy_name : '策略名称',
      strategy_applied:'所应用的策略',
      strategy_fence_scope : '作用范围',
      strategy_device: '设备策略',
      strategy_fence: '围栏策略',
      strategy_config: '配置策略',
      circle_inner: '围栏内禁用设备',
      circle_outer: '围栏外禁用设备',
      circle_close: '关闭',
      circle_open: '开启',
      fence_circle_set : '围栏圈定',
      device_list : '设备列表',
      device_search: '搜索',
      device_moveto: '移动到',
      device_add : '添加设备',
      dev_add:'设备添加',
      dev_edit:'设备编辑',
      device_batch_delete : '批量删除',
      device_batch_delete_confirm : '删除确认',
      device_batch_delete_confirm_tip : '确认删除这些设备，是否继续？',
      device_template_download : '模板下载',
      device_import : '批量导入',
      device_imp:'设备导入',
      device_download_import:'下载导入模板',
      device_moreoper:'更多操作',
      device_log : '设备上传诊断日志',
      device_upload_pp_log : '设备上传应用日志',
      device_log_refresh : '刷新列表',
      device_log_time : '日志时间',
      download : '下载',
      app_id : '应用ID',
      device_warn_type : '预警类型',
      device_warn_level : '预警级别',
      device_code : '设备编号',
      device_type : '设备类型',
      device_belong_company:'所属公司',
      device_map_change:'切换',
      device_number_type:'当前设备数量:',
      device_holder : '持有人',
      device_login_user : '登录人',
      device_fence_status : '围栏状态',
      device_fence_closed : '已关闭',
      device_fence_opened : '已开启',
      device_warn_status : '预警状态',
      device_warn_warn : '预警',
      device_warn_normal : '正常',
      device_status : '设备状态',
      device_active_strategy:'所应用的策略',
      device_active_status:'活动状态',
      device_activation_status:'激活状态',
      device_active_online:'在线',
      device_active_offline:'离线',
      device_activation_yes: '激活',
      device_activation_no:'未激活',
      device_status_unknown:'未知',
      device_status_normal : '正常',
      device_status_warn : '预警',
      device_status_forbidden : '禁用',
      device_order_forbidden:'设备禁用',

      device_status_locked : '锁屏',
      device_template : '设备信息导入模板',
      app_coverage_upgade1 : '覆盖升级之后，之前的版本(',
      app_coverage_upgade2 : ')将会被替换，确认要覆盖此灰度版本吗？',
      app_to_edition1 : '转为正式版后，之前的灰度版本(',
      app_to_edition2 : ')将会被替换，确认将要此灰度版本转为正式版吗？',
      app_normal_upgrade1 : '覆盖升级之后，之前的正式版本(',
      app_normal_upgrade2 : ')将会被替换，确认要覆盖此正式版本吗？',
      device_lock_tip : '此操作将会锁定此设备屏幕, 是否继续?',
      device_forbidden_tip : '此操作将会禁用设备, 是否继续?',
      device_unforbidden_tip : '此操作将会解禁设备, 是否继续?',
      device_tip:'提示',
      device_restart_tip : '此操作将重启设备,是否继续?',
      device_closeFence_tip : '此操作将关闭围栏,是否继续?',
      device_openFence_tip : '此操作将开启围栏,是否继续?',
      device_shutdown_tip : '此操作将关机设备,是否继续?',
      device_ring_tip : '设备将以最大铃声响铃，设备端仅可通过重启关闭响铃',
      device_extract_dvc_logs_tip : '此操作将要提取设备日志，是否继续？',
      device_restore_tip:'此操作将设备恢复出厂设置,是否继续?',
      device_delete_tip : '此操作将会移除该设备所有信息, 是否继续删除?',
      device_clear_tip : '此操作将会清除此设备数据, 是否继续?',
      device_disabled_tip:'此操作将要锁定设备，留言将显示在设备的锁定界面上, 是否继续?',
      device_disabled_msg:'您好，这是我丢失的设备，里面有对我十分重要的信息，希望您看到留言后及时与我联系，非常感谢。\n' +
        '联系方式：',
      device_available_tip:'此操作将会解除禁用设备, 是否继续?',
      app_config_tip : '此操作将会删除此应用的配置文件, 是否继续?',
      device_imei : 'IMEI',
      device_sim : 'SIM',
      device_description : '设备描述',
      device_address : '设备地址',
      device_fnsn : 'FNSN',
      device_type_tip : '请选择设备类型',
      device_detail : '设备详情',
      device_operator : '运营商',
      device_call_time : '通话时长',
      device_sign : '设备签名',

      device_version : '系统版本',
      Android_version:'Android版本',
      device_appcenter_version : '应用版本',
      devcice_os_version:'OS版本',
      device_collect_time : '采集时间',
      device_battery : '电量',
      device_current_battery : '当前电量',
      device_geo : '位置',
      device_current_geo : '当前位置',
      device_warn_detail : '预警详情',
      device_app : '设备应用',
      device_instruction : '指令管理',
      device_instruction_edit : '编辑',
      device_instruction_lock : '屏幕锁定',
      device_instruction_forbidden : '禁用',
      device_instruction_enable :'启用',
      device_instruction_delete : '设备删除',
      device_delete_temp_again:'   温馨提示：是否删除该设备？',
      device_instruction_unforbidden : '解禁',
      device_order_unforbidden : '设备解禁',
      device_instruction_unlock : '屏幕解锁',
      device_order_unlock:'解除锁屏',
      device_order_restart:'设备重启',
      device_order_shutdown:'设备关机',
      device_order_restored:'设备恢复出厂',
      device_instruction_clear : '数据清理',
      device_instruction_log : '设备日志',
      device_instruction_app_log: '应用日志',
      device_instruction_open_fence : '开启围栏',
      device_instruction_close_fence : '关闭围栏',
      device_instruction_history : '历史指令',
      device_instruction_manager : '当前管理设备',
      device_instruction_time : '日志时间',
      device_instruction_type : '指令类型',
      device_status_unlock : '解锁',
      device_status_unforbidden : '解禁',
      device_locate : '定位',
      device_app_log : '应用日志',
      device_diagnosis : '诊断日志',
      device_delete : '删除',
      device_clear_data : '数据清理',
      device_fence_open : '开启围栏',
      device_fence_close : '关闭围栏',
      device_path_applog : '指定目录应用日志',
      device_instruction_unknow : '未知',
      device_instruction_status : '指令状态',
      device_instruction_status_sended : '已发送',
      device_instruction_status_performed : '已执行',
      device_instruction_sender : '发送人',
      device_instruction_send_time : '发送时间',
      device_geo_success : '定位指令发送成功',
      device_function_disable_list : '功能禁用列表',
      device_function_recovery : '恢复全部功能',
      device_function_disable : '设备将会终止勾选的服务, 是否继续?',
      device_function_recovery_all : '此操作将会恢复设备所有功能, 是否继续?',
      device_import_tip : '如果导入的文件数据与原有的数据重复，请选择处理方式',
      device_import_original_data : '以原有数据为准',
      device_import_file_data : '以文件中数据为准（默认）',
      device_import_btn : '点击选择需要导入的文件',
      device_lock_pwd : '锁屏密码',
      device_management : '管理',
      device_voice_jy : '设备静音',
      device_voice_jzjy : '禁止设备静音',
      device_voice_max : '设备声音最大化',

      device_del_app: '删除应用',
      device_sys_log: '系统日志',
      device_error_log: '异常日志',
      device_log_TUSN: 'TUSN',
      device_log_type: '获取方式',
      devcei_log_operating: "操作",
      device_updata_sys_log:'上传日志',
      device_log_refresh_b:'刷新',
      device_deleteapp_tip: '此操作将会卸载设备上的应用, 是否继续?',

      device_basic : '基本信息',
      device_app_info : '应用信息',
      device_sd_control : 'SD卡控制',
      device_log_info : '日志信息',
      device_phone_info : '电话信息',
      device_message_record : '短信记录',
      device_location_info : '位置信息',
      device_warn_info : '预警信息',
      device_wifi_dosage : 'WiFi用量',
      device_storage_capacity : '存储容量',
      device_data_throughput_dosage : '数据流量用量',
      device_communication_records :'通话记录',
      device_device_contacts :'设备联系人',
      device_message_type :'短信类型',
      device_message_number :'通讯号码',
      device_message_contacts :'联系人',
      device_message_date :'通讯时间',
      device_communication_type :'通话类型',
      device_communication_number :'通话号码',
      device_communication_time :'通话时间',
      device_phone_number :'电话号码',
      device_call_in :'呼入',
      device_call_out :'呼出',
      third_app_select_app : '请选择应用',
      third_app_select_device : '请选择设备',
      third_app_config_upload : '配置文件上传（以最后一次上传内容为准）',
      click_upload : '点击上传（文件格式:txt）',
      click_upload_xls : '点击上传（文件格式xls）',
      fetch_device_log : '抓取设备日志',
      tms_upload : 'TMS上传',
      tms_name : '名称',
      tms_package_name : '包名',
      tms_size : '大小',
      tms_version_name : '版本名',
      tms_version_code : '版本号',
      tms_create_user : '创建人',
      tms_remark : '描述',
      tms_create_time : '创建时间',
      tms_upload_tip : '将文件拖到此处或点击此处',
      tms_logo : 'logo',
      app_center_delete_tip : '此操作将会删除设备上的应用中心, 是否继续?',
      device_directory_upload : '指定目录上传',
      directory_upload_tip : '请输入指定目录',
      app_log_flag : '获取方式',
      app_get_directly : '直接',
      app_get_directory : '目录',
      app_directory : '指定目录',
      config_download : '配置下载',
      editApp : '编辑应用',
      select_organization :'分配机构',
      click_select :'点击分配',

      organization_allot:'分配机构',
      telephone_add:'添加电话号码',
      telephone:'电话号码',

      save : '保存',
      updateInfo:'更新信息',

      btnadd:'添加',
      btnupdate:'修改',
      inputsn:'输入sn号添加',
      snexport : '批量导入',
      sn_temp_down : '下载模板',
      uploadWaiting:'请稍后，数据正在上传处理',

      snno:'序号',
      snnum:'sn',
      devType:'机型' ,
      sn:'SN号',
      add_remark:'添加备注',
      edit_remark:'编辑备注',
      sure:'确定',
      remark_tips:'请输入不超过200个字符',
      orgName:'机构',
      snstatus:'状态',
      snstatus_normal:'正常',
      snstatus_non_existent:'不存在',
      snstatus_sn_repeat:'sn重复',
      snstatus_sn_published:'已发布sn重复',
      snstatus_sn_notcontain: '设备类型不匹配',
      onemorevertips: "提示:其中{0},{1}个应用存在多个版本,默认发布最高版本。",
      addBanner:'添加广告',
      link:'链接',
      editBanner:'编辑广告',
      selectAll:'全选',
      search_app_name:'搜索应用名',
      autoOnShelf:'自动上架',
      handOnShelf:'手动上架',
      uploadedApp:'已上架应用',
      unuploadedApp:'未上架应用',
      detail:'详情',
      export:'导出',
      device_se_version:'SE版本',
      app_currently_installed:'当前已装应用',
      app_install_num_zero:'当前已安装应用为0',
      activation_time:'激活时间',
      last_active_time:'最后活跃时间',
      myDevice_fileName:'我的设备',
      app_param_error_fileName:'错误参数配置',
      device_app_fileName:'设备应用',
      app_delete_tip:'确认删除该app版本，是否继续？',
      app:'应用',
      app_del_tip:'会被删除，请慎重操作,已安装在设备上的应用不会被删除',
      version:'版本',
      deviceLifeCycle:{

        filename:"设备生命周期",
        shipedEquipment:"已发货设备(台)",
        cumulativeActivatedEquipment:"累计激活设备(台)",
        deviceDataOverview:"设备数据总览",
        shipDate:"发货日期",
        activationDate:"激活日期",
        search_sn_tip:"输入SN查询",
        search_deviceTytp_tip:"机型选择",
        queryBtn:"查询",
        export:"导出",
        collectDateBegin:"开始日期",
        collectDateEnd:"结束日期",
        SN:"SN号",
        deviceType:"机型",
        shipTime:"发货时间",
        activationTime:"激活时间"
      },
      inter_sn_query:'输入SN查询',
      device_type_choose:'机型选择',
      online_status_choose:'在线状态',
      apply_install:'应用安装',
      three_apply_install:'第三方应用安装',
      usb_debug:'USB调试',
      power_flow_config:'耗电&流量配置',
      high_precision_model:'高精度模式',
      balance_model:'均衡模式',
      energy_conservation_model:'节能模式',
      custom_model:'自定义模式',
      high_precision_model_detail:'使用推送，地图采用高精度，轮询时间为10分钟，电量缓存频率为1分钟',
      balance_model_detail:'使用推送，地图采用节能模式，轮询时间为3小时, 电量缓存频率为10分钟',
      energy_conservation_model_detail:'使用推送，地图采用节能模式，轮询时间为24小时, 电量缓存频率为64分钟',
      push_setting:'推送设置：',
      using:'使用',
      onUsing:'不使用',
      map_setting:'地图采用模式设置：',
      preciseness:'高精准',
      energy_conservation:'节能',
      polling_time_setting:'轮询时间设置：',
      power_cache_frequency_setting:'电量缓存频率：',
      network_connection_frequency:'网络信息缓存频率：',
      minute:'分钟',
      custom_start:'应用',
      start_success:'应用成功',
      time_input:'轮询时间只能输入整数,最小为5分钟且不能超过24小时（即1440分钟）',
      deviceType_searchTip:'请选择机型',
      shelfList_searchTip:'搜索应用名称/机构名称',
      shelfList_searchTip1:'搜索应用名称',
      device_export_rule:'请下载模板导入终端',
      inputSnOrRemark:'输入SN号/备注',
      inputSearchAddress:'输入设备位置',
      messagePush:'消息推送',
      enterMessage:'请输入推送的消息',
    },
    bootAni:{
      dvcTypeSelect: '机型选择：',
      boot_Ani_Method_select:'选择动画：',
      boot_ani_method_default:'默认动画',
      boot_ani_method_customize:'自定义动画',
      select_zip:'选择ZIP包',
      zip_rule:'图片制作规则',
      download_boot_temp:'下载模板',
      boot_load_ing:'开机动画预览文件正在生成，请耐心等待。',
      boot_join_ing:'加载中...',
      cur_no_boot:'当前无动画',
      choice_boot:'请点击"选择ZIP包"按钮，制作自定义开机动画。',
      play_speed:'播放速度：',
      second:'/ 秒',
      apply_boot:'应用到所选设备',
      zip_parse_fail:'ZIP解析失败',
      zip_parse_fail_desc:'ZIP解析失败，具体请参照模板以及ZIP制作规则。',
      select_true:'确定',

    },
    error: {
      boot_ani_type_error:'开机动画文件格式为ZIP',
      boot_ani_max_file:'开机动画压缩文件最大支持20M',
      packagename_exist:'该应用包名已存在，请勿重复添加',
      app_blank_necessary_conflict:'应用黑名单与必装应用不能设置为同一个应用',
      safedesk_hideapp_conflict: '安全桌面应用与隐藏App图标应用不能设置为同一个应用',
      wifi_exist:'该wifi已存在请勿重复添加',
      wifiblank_ssid_conflict:'wifi黑名单设置与wifi远程设置冲突',

      sn_is_not_empty:'设备编号不能为空',
      ssid_exist_blanklist:'ssid与wifi黑名单冲突',
      strategy_data_safeType:'请选择安全类型',
      tel_space_rule: '电话号码不能为空',
      packagename_rule: '包名、应用名称不能为空',
      packagename_rule2: '请输入正确的包名',
      wifiname_rule: 'WiFi名称不能为空',
      select : '请选择',
      param_error : '参数有误',
      username_rule : '账号不符合规则',

      username_rule_1 : '账号仅包含【字母、数字、下划线、-】,且必须以字母开头,长度5-20',
      password_more_6 : '密码不能小于6位',
      password_less_20 : '密码不能大于20位',
      password_rule_1 : '密码长度6-16位,必须含字母及数字',
      verifycode_eq_4 : '验证码为4位',
      verifycode_empty:'请输入验证码',
      email_rule : '请输入正确的邮箱地址',
      sub_account_name_tip:'请输入子商户名称',
      tel_rule : '请输入正确的手机号码',
      tel_rule2: '请输入正确的电话号码',
      nickname_rule : '用户名只包括字母数字和中文,长度为1-10,请输入正确的用户名',
      dvcGroup_rule: '分组名称长度为1-30',
      selectsex : '请选择性别',
      selectrole : '请选择角色',
      selectmanuauth : '请选择菜单权限',
      selectuser : '请选择用户',
      job_rule : '长度在 0 到 50 个字符',
      description_rule : '长度在 0 到 100 个字符',
      password_rule : '长度在 6 到 20 个字符',
      avatar_rule : '头像大小不得超过500KB',
      avatar_format_rule : '只能上传jpg,jpeg格式的文件',
      apk_format_rule : '只能上传apk格式的文件',
      apk_size_rule : 'apk文件不得大于1GB',
      password_inconsistency : '两次输入密码不一致',
      password_old : '请输入原来的密码',
      password_new_more : '请再次输入新密码',
      password_length : '长度在 8 到 20 个字符',
      organizationid_rule : '仅包含[字母、数字],长度1-20个字符',
      organizationname_rule : '仅包含[汉字,字母,数字,空格,@，_，-，.],长度在 1 到 30 个字符',
      organizationalias_rule : '仅包含[汉字、字母、数字、空格、.],长度在 0 到 10 个字符',
      organizationprincipal_rule : '仅包含[汉字、字母、数字],长度在 0 到 10 个字符',
      organizationdescription_rule : '仅包含[汉字、字母、数字],长度在 0 到 200 个字符',
      organizationaddress_rule:'仅包含[汉字、字母、数字],长度在 1 到 100 个字符',
      appname_rule : '长度在 1 到 30 个字符',
      appfeature_rule : '长度在 0 到 200 个字符',
      appproducer_rule : '长度在 0 到 50 个字符',
      bussType_rule :"行业分类不能为空",
      devType_rule:'设备类型不能为空',
      devType_rule2:' ',
      appdesc_rule : '长度在 0 到 100 个字符',
      updatebrowser : '请更新浏览器',
      content_rule : '消息内容不能为空',
      title_rule : '消息标题不能为空',
      strategy_name_rule : '策略名称为1-15位 中英文、数字、- 组成',
      device_code_rule : 'SN编号最长为30个字符，可输入字母和数字',
      device_imei_rule : 'IMEI编号最长为20个字符，可输入字母和数字',
      device_sim_rule : '请输入合法SIM卡号',
      device_description_rule : '最长为100个字符',
      device_import_rule :'只能导入xls格式的文件',
      device_import_size_rule : '导入文件不得超过5MB',
      file_send_size_rule : '导入文件不得超过100MB',
      third_config_rule :'只能上传txt格式的文件',
      third_app_size_rule : 'txt文件不得大于10KB',
      password_confirm_error : '密码错误',

      simplePassword:'你设置的密码太简单了，为了企业信息安全，请重新设置',
      numberLetterRepeatFiveTimes:'不可包含5个及以上重复数字或字母',
      fiveContinuousNumber:'不可包含5个及以上连续数字',
      atLeastSixContainLetterNumber:'密码最少6位,必须含字母及数字',


      job_rule_1:'职位仅包含【中文、字母、数字、-】,长度0-50',
      nickname_rule_1 : '姓名仅包含【中文、字母、数字、下划线、-】,长度1-10',
      email_rule_1 :'邮箱只允许英文字母、数字、下划线、英文句号、@符号以及中划线组成',
      description_rule_1:'描述仅包含【中文、字母、数字、逗号、句号】,长度0-100',

      organizationaddress_rule_1:'机构地址仅包含[汉字、字母、数字],长度在 0 到 100 个字符',
      organizationname_rule_1 : '机构名称仅包含[汉字、字母、数字、空格],长度在 1 到 30 个字符',
      organizationalias_rule_1: '机构简称仅包含[汉字、字母、数字、空格],长度在 0 到 10 个字符',
      organizationprincipal_rule_1 : '机构联系人仅包含[汉字、字母、数字],长度在 1 到 20 个字符',
      organizationdescription_rule_1 : '机构描述仅包含[汉字、字母、数字],长度在 0 到 200 个字符',

      currentorganizationlogotips:'该标志为当前账号所属机构',

      strategy_name_rule_1:'最多不超过15个字',
      strategy_name_exist:'该名称已存在，请重新输入策略名称',
      strategy_data_not_exist:'当前没有数据',
      strategy_select_not_one:'请选择一条数据',
      device_import_data_error : '您导入的数据中有不合法数据，合法数据已为您导入，错误数据已为您生成报表！',

      sn_import_size_rule : '导入文件不得超过5MB',
      sn_import_rule :'只能导入xls格式的文件',
      sn_import_error:'文件导入异常,请联系管理员!',
      sn_import_model_error:'导入设备为空或者导入模板错误，请检查模板',
      cannot_pub_by_sn:'当前版本不能灰度发布!',

      sn_import_count:'导入数',
      sn_import_error_count:'失败数',
      sn_import_success_count:'成功数',

      image_format_rule:'请上传正确格式的图片',
      package_conflict:"包名不一致，请重新上传",
    },
    tip : {
      select_sn_unbind:'请勾选需要解绑的设备',
      boot_ani_effective_success:'开机动画生效成功',
      boot_ani_save_success:'开机动画保存成功',
      boot_ani_parse_success : '开机动画解析成功',
      uploadbanner:'请上传图片',
      repeatClick: '请勿重复点击',
      operation_success : '操作成功',
      ring_pwd : '密码必须为四位数字',
      wait_a_minute : '请稍后操作',
      operation_fail : '操作失败',
      operation_fail_upload : '上传文件失败',
      device_group_select:'请选择设备组',
      device_group_add_device_down:'未分组设备下不能添加设备组',
      device_group_delete_device_down:'未分组设备不能被删除',
      device_group_edit_device_down:'未分组设备不能被编辑',
      device_fence_circlePath_tip:'围栏范围不能为空，且必须为数字',
      device_fence_cricle_center_lng:'围栏中心经度必须是数值，取值在-180~180之间',
      device_fence_cricle_center_lat:'围栏中心纬度必须是数值，取值在-90~90之间',
      device_fence_cricle_center_radius:'围栏半径必须是数值，且必须大于0',
      device_fence_circle_center_param_error:'设备围栏参数错误',
      device_fence_circle_frequency_param_error:'发送频率只能是正整数',
      device_fence_circle_name_param_error:'规则名称不能为空',
      device_fence_circle_mail_error:'邮箱格式错误',
      strategy_data_send_tip : '请选择设备上传的信息',
      strategy_data_fence_tip : '请设置围栏信息',
      node_change_tip : '请选择需要切换的节点',
      loading_wait_tip: '加载中 请稍等',
      uploading:'上传中...',
      del_app_command_success : '删除指令已发送',
      selectappversion:'请选择应用版本(必选)',
      selectpublishtype:'请选择发布方式(必选)',
      publishtypebynormal :'正常发布',
      publishtypebysn :'SN发布',
      selectorgnodes:'请选择可见范围(必选)',
      shelfAppWhenCreateOrgs :"新建机构发布自动同步此应用",
      appversiontips:'版本提示',
      banner_tip:'上传尺寸：672*290px，格式：jpg/png，大小不超过：500KB，最多不超过五张',
      uploadSpecification:'上传规范',
      appDescPicSize : '图片大小不得超过5MB!',
      appBannerPicSize:'图片大小不得超过500KB!',
      appDescFormatter : '请上传正确格式的图片',
      appDescUploadError : '图片上传出错!',
      appAvatarSize : '图片大小不得超过100KB!',
      appAvatarNotNull : "应用图标不存在",
      appDescNotNull : "请上传应用描述图片",
      appNameNotNull : "请输入应用名称!",
      appDevTypeNotNull : "请勾选设备类型!",
      appDescTooLong:'应用简介超过1000字符',
      addBannerTip:'上传图片（672*290及500KB以内的png/jpg）：',
      confirmBannerDelete:'确认删除此广告？',
      app_version_manage_tip1 : '升级功能说明',
      app_version_manage_tip2 : '1、灰度升级：新版本只在有限的指定范围内上架，其他机器继续使用全部部署的正式版本，适用于新版本小范围使用；',
      app_version_manage_tip3 : '2、覆盖升级：使用最新版本替换上传的灰度版本，适用于上次的灰度版本有BUG，上次的灰度版本会下架；',
      app_version_manage_tip4 : '3、正常升级：不需要灰度升级，直接正常升级，所有机器将使用新版本，老版本自动下架；',
      app_version_manage_tip5 : '4、转为正式版：需要灰度范围为全部，并替换之前的正式版本，老版本将自动下架；',
      app_version_manage_tip6 : '5、增加灰度范围：在原来的灰度范围之上增加部署范围，适用于小范围试用时没有发现问题，扩大试用范围来确认是否有效；',
      app_unreview_tip : '审核中，大概需要1个工作日，请耐心等待（本商户的设备已上架该版本应用，无需审核。）',
      handPut:'确认切换为手动上架模式？',
      autoPut:'确认切换为自动上架模式？（未上架应用将自动上架）',
      remoteDevice_details_fail : '此设备还未上传详细信息',
      remoteGroup_search_null : '未搜索到此分组',
      silentApp_tip: '你可以根据机型设置不同的默认启动应用',
      no_silentApp_tip:'暂无默认启动应用',
      confirmSilentAppDelete:'此操作将移除默启应用，是否继续？',
      numberGreaterThanZero:'数字必须大于0',
      fileTypeNotSupport:'文件类型不支持',
      mustApk:'文件类型不正确，请上传APK文件',
      mustFile:'文件类型不正确，请上传JSON文件',
      cus_max_size:'最大上传100MB文件',
      user_permissions_not:'用户没有相关操作权限',
    },
    login: {
      title : '商户终端管理平台',
      username:'用户名',
      usernametip : "账号/邮箱",
      password : "密码",
      verifycode : '验证码',
      authedicate : '验证码',
      rememberMe:'记住用户名',
      loginbtn : '登录',
      register_btn:'注册',
      platformName:'合作伙伴平台',
      login_check_company_input:'请点击商户信息管理-公司信息页面填写公司信息',
      repeat_login:'当前账号已登录，是否强制登录',
      login_password_overdue:'密码已经过期，请重新设置新的密码！',
      login_password_expiring:'密码有效期不足七天请尽快更新密码！',
    },
    register:{
      register_mailbox:'注册邮箱',
      set_password:'设定密码',
      partner:'合作平台伙伴',
      verify_identidy:'验证身份',
      account:'商户',
      active_success:'激活成功',
      active_fail:'激活链接已失效',
      lock_tip1: '登录失败次数过多，账号已被锁定。',
      lock_tip2: '点击下方按钮发送解锁邮件到已提供的邮箱',
      btn_send: '发送解锁邮件',
      tip_sending: '邮件发送中...',
      tip_send_success: '邮件发送成功',

      email_tip:'请输入邮箱地址',
      user_name_tip:'请输入用户名',
      password_tip:'请输入密码',
      password_again:'确认密码',
      password_again_tip:'请确认密码',
      verify_code: '请输入验证码',
      register_now:'立即注册',
      forget_password:'忘记密码?',
      register_email_send_tip1:'激活邮件已发送至您的注册邮箱',
      register_email_send_tip2:'请在24小时内',
      register_email_send_tip3:'点击邮件内链接完成注册',
      register_email_check:'立即查收邮件',
      agree_service_items:'同意服务条款',
      no_email_received:'未收到邮件',
      resend_email:'重发邮件',

      register_email_no_send:'未收到邮件',
      register_email_again_send:'重新发送邮件',
      next_step:' 下一步',


    },

    reset:{
      register_password:'重置密码',
      email_reset_password:'邮箱重置',
      tel_reset_password:'手机号重置',
      email_check_reset_password:'邮箱验证',
      button_content_step1:'发送验证码',
      again_send_code:'重新发送验证码',
      resend_code_again_after:'后重新发送',
      next_step:'下一步',
      email_reset:'重置邮箱',
    },
    companyinfo:{
      copy:'复制',
      company:'公司',
      select_country:'请选择国家/地区',
      company_name_rule:'请输入公司名称',
      company_address_rule:'请输入公司地址',
      company_website_rule:'请输入正确的网址',
      company_area_rule:'请输入公司所在区域',
      company_credential_rule:'请上传营业执照或者身份证',
      company_review_tip:' 审核中，大概需要一个工作日，请耐心等待',
      image_format_rule:'请上传正确格式的图片',
      image_size_rule:'图片最大为5M',
      company_image_upload_error:'证件图片上传失败',
    },

    groupManage:{
      add:"新增",
      group_name:"分组名称",
      address_info:"位置信息",
      admin_name:"管理员姓名",
      contact_information:"联系方式",
      remarks:"备注",
      import_group:"导入组",
      clear_group_data:"清除已有分组",
      import_temp_download:"下载Excel模板",
      error_group_download:"下载",
    },

    remoteConfig:{
      min_port:'端口为数字,首位应大于0且长度在2-10位',
      min_mms_port:'彩信端口为数字,首位应大于0且长度在2-10位',
      port_mix:'请输入2-10位数字',
      apn_setting:'APN设置',
      wifi_setting:'WIFI设置',
      function_control:'功能设置',
      ssid:'SSID',
      wifi_whitelist_setting:'WIFI白名单设置',
      name:'名称',
      type:'类型',
      pus_range:'推送范围',
      status:'状态',
      execution_progress:'执行进度',
      operate:'操作',

      select_push_range:'选择推送范围',
      config_name:'规则名称',
      config_name_not_empty:'规则名称不能为空',
      apn_not_empty:'APN不能为空',
      apn_name_not_empty:'APN名称不能为空',
      mcc_not_empty:'MCC不能为空',
      mnc_not_empty:'MNC不能为空',
      my_config_name:'我的APN规则',
      apn_name:'APN名称',
      apn:'APN',
      agent:'代理',
      port:'端口',
      user_name:'用户名',
      password:'密码',
      server:'服务器',
      mmsc:'MMSC',
      mms_agent:'彩信代理',
      mms_port:'彩信端口',
      mcc:'MCC',
      mnc:'MNC',
      authentication_type:'身份验证类型',
      apn_type:'APN类型',
      empty_null:'无',
      apn_protocpl_name:'PAP或CHAP',
      apn_protocol:'APN协议',
      config_name_not_null:'规则名称不能为空',
      apn_not_null:'APN不能为空',
      apn_port_must_number:'必须为2-10位数字',



      wifi_name:'名称',
      wifi_name_tip:'请输入名称',

      not_push:'未推送',
      already_push:'已推送',
      qr_code_generate_tip:'请填写设置信息后再生成二维码',
      qr_code_generate:'生成二维码',
      qr_code_generate_new_tip:'点击生成WIFI连接二维码，设备端可通过扫描二维码，连接对应的网络',
      wifi_setting_push:'WIFI设置推送',
      config_push:'推送',
      config_edit:'编辑',


      delete_apn_config_batch:'删除APN配置',
      delete_apn_config_batch_tip:'删除APN配置，设备端配置信息也随之删除，设备恢复原始设置，是否删除？',

      delete_wifi_config_batch:'删除WIFI配置',
      delete_wifi_config_batch_tip:'删除WIFI配置，设备端配置信息也随之删除，设备恢复原始设置，是否删除？',
      yes:'是',
      no:'否',

      add_wifi_whitelist:'WIFI白名单添加',
      whitelist_ssid:'白名单SSID',
      whitelist_ssid_tip1:'推送白名单后，设备仅可连接白名单的WIFI',
      whitelist_ssid_tip2:'(WiFi设置中的SSID默认加入白名单)；',
      whitelist_ssid_tip3:'若不推送白名单，WiFi连接不受限制。',
      whitelist_ssid_tip0:'请输入白名单SSID,不同SSID之间使用逗号分开,例:WIFI11,WIFI22,WIFI33',

      delete_wifi_whitelist_config_batch:'删除WIFI白名单配置',
      update_wifi_whitelist_no_ssid_delete:'此操作删除白名单规则中所有的白名单WIFI，白名单规则也会同步删除，',
      delete_wifi_whitelist_config_batch_tip1:'删除WIFI白名单配置，',
      delete_wifi_whitelist_config_batch_tip:'设备端配置信息也随之删除，设备恢复原始设置，是否删除？',
      wifi_whitelist_config_edit_tip:'WIFI白名单设置修改',
      wifi_whitelist_config_history_push:'Wifi白名单历史推送内容',
      wifi_whitelist_config_push:'WIFI白名单推送',
      push_wifi_whitelist_config_batch_tip:'推送WIFI白名单配置，是否推送？',


      enterPositiveInt:'请输入正整数',

      wifi_whitelist_select_group_error:'请选择一个设备分组',

      wifi_whitelist_ssid:'白名单网络名称',

      wifi_whitelist_group_wifi_ssid:'分组中WIFI配置内的SSID',
      wifi_whitelist_group_wifi_ssid_new:'手动添加',

      wifi_whitelist_group_ssid_list:'WIFI 配置内的SSID',

      wifi_whitelist_look_more:'查看更多',

      wifi_whitelist_name_default:'我的WIFI白名单',

      wifi_whitelist_name_is_exists:'请输入规则名称',

      wifi_whitelist_push_range_is_exists:'请选择推送范围',

      wifi_whitelist_ssid_name_is_exists:'请添加白名单wifi的网络名称',

      wifi_whitelist_ssid_empty:'无信息',

    },

    customDesk:{
      cusDeskType:'桌面类型',
      version:'版本',
      name : '配置名称',
      pushGroups : '推送范围',
      dvcType: '机型选择',
      packageName : '软件包名',
      unlockPwd : '解锁密码',
      hideStatusBar : '隐藏状态栏',
      hideNavigationBar: '隐藏导航栏',
      timedUnlock: '定时解锁',
      lockTime: '锁屏时长',
      template: '自定义桌面模板',
      layout:'图标布局',
      row: '行',
      column: '列',
      templateFile: '自定义模板文件',
      pic: '背景图片(文件格式支持jpg、jpeg、png,最大支持30M图片)',
      empty_custom_desk_tip:'请填写配置名称',
      empty_custom_desktop_tip:'请填写桌面名称',
      rule_name:'规则名称',
      cus_desk_set:'自定义桌面',
      del_desk_tip:'删除自定义桌面',
      del_desk_tip1:'删除自定义桌面，设备端配置信息也随之删除，设备返回安卓默认桌面，是否删除？',
      cus_desk_push:'自定义桌面推送',
      edit_desk:'编辑自定义桌面',
      operate_record_detail:'操作记录详情',
      select_rang:'选择范围',
      hour:'小时',
      stand_template:'标准模板',
      stand_template_tips:'注意：使用标准模板时，请确保设备安装了企业桌面App',
      customize:'自定义',
      custom_template_file:'自定义模板文件(请上传apk格式文件最大支持100M)',
      submit:'确定添加',
      yes:'确定',
      download_config:'下载已经配置的文件',
      lockTimeRule:'锁屏时长应在1-48之间',
      rowRule:'行应在1-4之间',
      colRule:'列应在2-5之间',
      default_cus_name:'我的自定义桌面规则',
      default_apk_name:'我的应用包名',
      upload_desktop_app:'请上传自定义桌面应用',
      upload_config_file:'请上传配置文件',
      admin_password_or_app_package_is_not_null:'管理员密码和应用包名不能为空',
      admin_password_error_tip:'管理员密码不能有中文',
      upload_wallpaper_error:'请上传壁纸文件',
      add_package_name_tip:'可支持多个应用显示在桌面，不同应用包名直接用“,”分隔',
      custom_config_file:'请上传已配置好的企业模式profile',
      custom_wallpaper:'请上传壁纸(只允许jpg,jpeg,png格式图片)',
      export_settings_property_json_description:'请在模板机上将企业模式完成配置后导出。导出的文件保存在sdcard/Custom_Local_Server目录下的 settings_property.json。可将此json文件通过ums下发。',
      customizeTemplate:'自定义模板',
      normalTemplate:'标准模板',
      configMethod:'配置方式',
      uploadWallpaper:'壁纸上传',
      configFileUpload:'配置文件上传',
      wallpaperUpload:'上传壁纸',
      noWallpaperUpload:'不上传壁纸',
      normalConfig:'标准配置',
      wallpaperName:'壁纸',
      configName1:'settings_property.json',
      desktopName:'桌面名称',
      adminPassword:'管理员密码',
      desktopAppPackage:'桌面应用包名',
      appIconSize:'应用图标大小',
      small:'小',
      normal:'常规',
      nax:'大',
      oversized:'超大',
    },
    statistic: {
      user_statistic : '用户数',
      device_statistic : '设备数',
      device_status_statistic : '设备状态',
      device_operator_statistic : '运营商',
      device_system_statistic : '操作系统',
      show : '显示',
      hide : '隐藏',
      device_status : '设备状态占比',
      device_operator : '运营商分布',
      operator_detail : '详情信息',
      device_status_detail : '设备详情',
      system_version_distribution: 'Android系统版本',
      OSVersion_distribution: 'OS版本信息',
      apps_installation : '应用安装详情',
      apps_installed : '已安装',
      apps_name : '应用名称',
      apps_device : '设备数'
    },
    dashboard : {
      users : '用户数',
      devices : '设备数'
    },
    account: {
      date : '最后更新时间',
      childName : '子商户名称',
      childShortName : '子商户简称',
      contacts :'联系人',
      type : '类型',
      status : '状态',
      appMarketConfig : '应用市场配置',
      operate: "操作",
      search_tip: '输入姓名或邮箱搜索',
      search_tip2: '输入商户名称或简称搜索',
      cooperative: '独立型',
      control: '管理型',
      review_yes:'正常',
      review_no:'审核未通过',
      review_wait:'待审核',
      wait_register:'已邀请，待注册',
      appMarket_free:'完全独立自由的应用市场',
      appMarket_clone:'克隆母商户的应用市场',
      appMarket_choose:'从母商户的应用市场中选择',
      appMarket_parent:'母商户为子商户设置上架应用',

      account_child_name_tip:'请输入子商户名称',
      account_child_short_name_tip:'请输入子商户简称',
      account_child_short_namr_error_tip:' 仅包含[汉字、字母、数字、空格],长度在 0到 10 个字符',
      account_child_principal_tip:'请输入子商户联系人',
      account_child_email_tip:'请输入子商户管理员邮箱',

      add_control_account:'添加管理型子商户',
      add_cooperative_account:'添加独立型子商户',
      cooperative_account_tip1:'分配设备给子商户',
      cooperative_account_tip2:'独立管理设备',
      cooperative_account_tip3:'作为开发者发布应用',
      admin_mailbox:'管理员邮箱',
      control_account_tip2:'为子商户分配操作员',
      control_account_tip4:'母商户可以随意控制',
      cooperative_account:'管理型子商户',
      app_market_tip1:'选择管理【管理型子商户】应用市场的方式',
      app_market_free:'完全独立自由的应用市场',
      free_tip:'子商户可以从优之家应用市场所有应用中选择上架的应用',
      app_market_clone:'克隆母商户的应用市场',
      clone_tip:'子商户的上架应用始终与母商户保持一致，包括自动安装应用的设置行为和只限母商户渠道上架的应用，子商户的【应用列表】不能操作及管理，仅用于展示',
      app_market_choose:'从母商户的应用市场中选择',
      choose_tip:'子商户在母商户上架应用的范围内挑选应用，包含只限主商户渠道上架的应用',
      app_market_parent:'母商户为子商户设置上架应用',
      parent_tip:'完全由母商户设置子商户应用市场所有内容，子商户的【应用列表】不能操作及管理，仅用于展示',
      app_market_tip2:'把管理型子商户转换为独立型子商户',
      transfer:'转换',
      transfer_to_cooperative:'转换为独立型子商户',
      transfer_tip:'管理型子商户可以转换为独立型子商户，将管理权还给子商户，转换之后将不能再切换回管理型子商户',
      setting:'设置',
      to_management:'去管理',
    },

    operate:{
      search_tip: '输入昵称或邮箱搜索',
      operate_name:'姓名',
      operate_email:'邮箱',
      operate_role:'角色',
      operate_permission:'权限',
      operate_status:'状态',
      operate_operate:'操作',
      operate_admin:'管理员',
      operate_operator:'操作员',
      operate_status_no_active:'未激活',
      operate_status_active:'已激活',
      operate_permission_select:'选择权限',
      admin_all_permission:'全部权限',
      operate_del_tip:'此操作将会删除操作员，是否继续？',
      operate_admin_password_tip:'请输入当前管理员密码',
      operate_transfer_admin_tip:'此操作将会删除操作员，是否继续?',
      operate_email_transfer_select_tip:'请选择需转交的操作员',
      add_operator:'添加操作员',
      transfer:'转交',
      remove:'移除',
      transfer_permission:'转交权限',
      transfer_permission_tip:'请选择新的管理员，转交后本商户将失去管理员权限',
      operate_permission_select_tip:'请选择操作员有权访问的功能模块',
    },
    personalinfo:{
      reset:'重置',
      personal_current_password:'当前密码',
      enterOldPass:'请输入当前密码',
      personal_new_password:'新密码',
      personal_again_password:'重复密码',
      personal_new_password_tip:'请输入新密码',
      personal_again_password_tip:'请确认密码',
      personal_name:'姓名',
      personal_name_tip:'请输入用户姓名',
      personal_new_email:'新邮箱',
      personal_again_email:'重复邮箱',
      personal_new_email_tip:'请输入新邮箱',
      personal_again_email_tip:'请确认新邮箱',
      personal_tel_concate:'联系电话',
      personal_tel_concate_tip:'请输入联系电话',
      password_change:'密码修改',
      password_change_tip:'建议定期修改密码以保护商户安全',
      display:'展开',
      hide:'隐藏',
      email_binding:'绑定邮箱',
      email_binding_tip_one:'你的邮箱',
      email_binding_tip_two:'若已停用，请立即更换，避免商户被盗',
      tel_binding:'绑定手机号',
      tel_binding_already:'已绑定',
      tel_binding_no:'未绑定',
      tel_rule:'请输入手机号',
    },

    deviceMap:{
      search_dropdown:'下拉菜单',
      device_map_merchant:'商户',
      device_map_sn:'SN',
      device_total_num:'设备总数',
      export_details:'导出设备位置',
      company_address_distributed:'商户位置分布',
      device_address_distributed:'设备位置分布',
      export_excel_name:'设备位置报表',
    },

    usageRecord: {
      documentDistribution:'【文件分发】',
      uninstallApp:'【卸载应用】',
      deviceDisable:'【设备禁用】',
      deviceUndisable:'【设备解禁】',
      deviceShutdown:'【设备关机】',
      deviceRestart:'【设备重启】',
      deviceMove:'【设备移动】',
      deviceLog:'【设备日志】',
      messagePush:'【消息推送】',
      device_groupDevice_ring:'【设备响铃】',
      deviceWifi:'【WiFi配置】',
      lateTaskExpired:'后任务到期',
      hasTaskExpired:'任务已到期',
      taskHasFinish:'任务已完成',
      moveToDeviceGroup:'移动到设备组:',
      uninstallAppName:'卸载应用名称:',
      appVersion:'版本:',
      fileName:'文件名称:',
      fileSize:'文件大小:',
      targetPath:'目标路径:',
      isCoverYes:'是否覆盖：是',
      isCoverNo:'是否覆盖：否',
      isRemindYes:'是否提示对方：是',
      isRemindNo:'是否提示对方：否',

      executed:'待执行',
      execution_succeed:'执行成功',
      execution_failed:'执行失败',
      clear_task_completed:'【清除锁屏密码】任务已完成！',
      clear_task_pending:'【清除锁屏密码】任务待执行！',
      recover_task_completed:'【恢复出厂设置】任务已完成！',
      recover_task_pending:'【恢复出厂设置】任务待执行！',
      uninstall_app_tip:'填写要卸载的应用包名，仅限一个（例如：ffsdsssd.dasdasd.sadasd）',
      app_package_confirm:'请确认包名的准确性',
      fail_overtime:'响应超时',
      fail_refuse:'app端拒绝',
      fail_notexist:'无此应用',
      fail_upinstall:'卸载失败',
      fail_forcestop:'强制停止',
      fail_download:'下载失败',
      check_log_file:'查看日志',
    },

    remoteManage:{
      shutdown :  '关机',
      restart: '重启',
      uninstallApp: '卸载应用',
      documentDistribution: '文件分发',
      deviceInfo: '设备信息',
      nativeInfo: '本机信息',
      dvcType:'机型',
      snNumber: 'SN号',
      sn_jd:'SN号',
      jd_device_info:'设备信息',
      sysVersion: 'OS版本',
      seVersion: 'SE版本',
      ufsVersion: 'UFS版本',
      basebandVersion: '基带版本',
      kernelVersion: '内核版本',
      screenResolution: '屏幕分辨率',
      currentPosition: '当前位置',
      electricity: '电量',
      hardwareInformation: '硬件信息',
      dvcMemory: '设备内存',
      storage: '存储',
      networkStatusInfo: '网络状态信息',
      SIMCardNum: 'SIM卡序列号',
      operator: '运营商',
      MACAddress: 'MAC 地址',
      IPAddress:'IP 地址',
      psam:'PSAM序列号',
      application: '应用',
      thirdApp: '第三方应用',
      systemApp: '系统应用',
      appName: '应用名',
      versionNum: '版本',
      packageName: '包名',
      size: '大小',
      deleteDvcGroup:'删除设备组',
      deleteDvcGroupTips:'您将删除该设备组，是否确定删除？',
      remoteDesktop:'开始远程',
      remoteDesktopRefuse:'设备拒绝远程连接请求',
      remoteDesktopControl:'正在远程控制设备',
      connectTiming:'连接超时',
      stopConnect:'后断开本次连接,请勿刷新页面',
      unknown:'未知',
      china_mobile:'中国移动',
      china_unicom:'中国联通',
      china_telecom:"中国电信",
      china_tietong:"中国铁通",
    },

    status:{
      online: '在线',
      offline: '离线'
    },

    addressManage:{
      fences_range:'围栏范围',
      fences_range_lng:'围栏经度',
      fences_range_lat:'围栏纬度',
      fences_range_radius:'围栏半径',
      fence_switch:'围栏开关',
      fence_switch_close:'关闭',
      fence_switch_open:'开启',
      fence_range_out_limit:'超出范围限制',
      mobile_data:'禁用移动数据',
      screen:'设备禁用',
      bluetooth:'禁用蓝牙',
      restore_device_date:'定时恢复出厂数据',
      add:'添加',
      save:'保存',
      change_deviceGroup_tip:'是否保存对上次的编辑？',
      meter:'米',
      checkFrequency:'邮件发送频率',
      enterCheckFrequency:'请填写邮件发送频率',
      receiveEmail:'接收邮箱',
      enterWarnEmail:'请填写接收触发警报的邮箱',

    },

    appWhitelist:{
      name:'名称',
      pushRange:'推送范围',
      content:'应用选择',
      app_name:'名称',
      app_version:'版本',
      app_package:'包名',
      add_app:"添加应用",
      app_name_is_empty:"应用名称不能为空",
      app_version_is_empty:"应用版本不能为空",
      app_package_is_empty:"应用包名不能为空",
      app_content_is_have_one:"保留一条数据",

      app_whitelist_name_is_empty:"应用白名单配置名称不能为空",
      app_whitelist_push_group_is_empty:'推送分组不能为空',
      app_whitelist_content_is_empty:"应用白名单内容不能为空",
      app_whitelist_check_app_name_is_empty:"应用选择的名称不能为空",
      app_whitelist_check_app_package_is_empty:"应用选择的包名不能为空",
      app_whitelist_del_tip:"确定删除应用白名单?",

      app_whitelist_tip:"提示",
      app_whitelist_tip1:"1、应用白名单开启后，会卸载非白名单应用！请慎重操作！",
      app_whitelist_tip2:"2、若手动安装新应用，请更新应用白名单，否则应用会安装失败。",
      app_whitelist_tip3:"3、若推送新应用，请更新应用白名单，否则应用会安装失败。",

      whitelist_app:'白名单应用',

      whitelist_tip:'该分组应用部署、自定义桌面推送过的应用',

    },

    appSurvivalList:{
      name:'名称',
      pushRange:'推送范围',
      content:'应用选择',
      app_name:'名称',
      app_version:'版本',
      app_package:'包名',
      add_app:"添加应用",
      app_name_is_empty:"应用名称不能为空",
      app_version_is_empty:"应用版本不能为空",
      app_package_is_empty:"应用包名不能为空",
      app_content_is_have_one:"保留一条数据",

      app_survivalList_name_is_empty:"应用保活名单配置名称不能为空",
      app_survivalList_push_group_is_empty:'推送分组不能为空',
      app_survivalList_content_is_empty:"应用保活名单内容不能为空",
      app_survivalList_check_app_name_is_empty:"应用选择的名称不能为空",
      app_survivalList_check_app_package_is_empty:"应用选择的包名不能为空",
      app_survivalList_del_tip:"确定删除应用保活名单?",

      app_survivalList_tip:"提示",
      app_survivalList_tip1:"1、应用保活名单开启后，会卸载非保活名单应用！请慎重操作！",
      app_survivalList_tip2:"2、若手动安装新应用，请更新应用保活名单，否则应用会安装失败。",
      app_survivalList_tip3:"3、若推送新应用，请更新应用保活名单，否则应用会安装失败。",

      survivalList_app:'保活名单应用',

      survivalList_tip:'该分组应用部署、自定义桌面推送过的应用',

    },
    appManage:{
      un_finsh_sn:'未完成设备',
      already_finsh_sn:'已完成设备',
      stop_finish_sn:'终止操作',
      execution_status:'执行状态',
      execution_tip_1:'未执行',
      execution_tip_2:'异常',
      execution_tip_3:'终止操作',
      failure_tip_1:'失败,下载失败',
      failure_tip_2:'失败,非白名单应用',
      failure_tip_3:'终止操作',
      see_details:'查看详情',
      implementation_details:'执行情况',
      again_push:'重新推送',
      stop_finish_sn_tip_1:"1、终端已安装相同应用&相同版本",
      stop_finish_sn_tip_2:"2、终端已安装相同应用&更高版本",
      stop_finish_sn_tip_3:"3、安装失败",
      stop_finish_sn_tip_4:"这些设备直接进入终止操作，减少流量电量的浪费",

    },
    pushDisplay:{
      range:{
        group_push:"分组推送",
        sn_push:"SN推送",
        table:{
          sn:"SN",
          group_name:"分组名称",
          device_type:"设备类型",
        },
        tip:{
          input_sn:"请输入SN",
          input_group_name:"请输入设备组名",
        }
      },
      schedule:{
        execution_progress:"执行进度",
        status:{
          un_finish:"未完成",
          finish:"已完成",
          finish_failure:"执行失败",
          finish_stop:"终止操作",
        },
        table:{
          sn:"sn",
          execution_status:"执行状态",
          group_name:"设备分组",
          implementation:"执行情况",
        },
        tip:{
          search_status_tip:"请选择执行状态",
          search_sn_tip:"请输入设备SN",
        },
        button:{
          query:"查询",
          export_excel:"导出报表",
        }

      },
    },
    param:{
      add:'添加',
      delete:'删除',
      config_name:'配置名称',
      push_range:'推送范围',
      push_status:'推送状态',
      finish_schedule:'完成状态',
      create_time:'创建时间',
      push:'推送',
      clone_config:'克隆',
      edit_config:'编辑',
      more_option:'更多',
      param_clone:'参数克隆',
      view_param:'参数查看',
      clone_tip:'您将要克隆此参数配置,是否继续?',
      can_not_clone_tip:'您刚克隆的规则将不会被创建,确定返回吗?',

      scan:'查看',
      operation:'操作',
      part_push:'部分推送',
      all_push:'全部推送',
      has_pushed:'已推送',
      no_push:'未推送',
      add_param:'新增参数',
      import:'导入',
      export:'导出',
      download_template:'下载模板',
      no:'序号',
      param_name:'参数名称',
      param_type:'参数类型',
      param_value:'参数内容',
      param_remark:'备注',
      param_edit:'编辑',
      save_and_return:'保存并返回',
      return_not_save:'返回',
      add_app_param_return_tip:'参数配置规则将不会被创建,确定要返回?',
      download_error_import_excel:'下载错误数据',
      type_of_text:'文本',
      type_of_switch:'开关',
      open:'开启',
      off:'关闭',
      enter_param_name_tip:'请输入参数名称',
      enter_param_value_tip:'请输入参数内容',
      enter_param_remark_tip:'请输入参数备注',
      enter_config_name:'请输入名称',
      enter_config_path:'格式如:/sdcard/MDM',


      add_param_title:'新增参数',
      edit_param_title:'编辑参数',
      import_param_title:'导入参数',
      param_config:'参数配置',
      param_add_name:'名称',
      param_add_path:'路径',
      param_version:'版本号：',
      param_pic:'壁纸',
      param_desk_method:'桌面类型',
      param_name_empty:'参数名不能为空',
      param_value_empty:'参数内容不能为空',
      param_path_empty:'路径不能为空',
      param_name_duplicate:'参数名称重复',
      config_name_empty:'名称不能为空',
      import_tmp_error:'导入失败，请导入正确的模板格式',
      param_list_empty:'参数列表不能为空',
      record_return:'返回',
      confirm:'确定',
      cancel:'取消',
      record:'记录',
      push_content:'推送内容',
      delete_app_param:'删除参数配置',
      delete_app_param_tip:'确定要删除选中的参数配置？',
      upload_param_config_tip:'请选择要上传的文件',
      return_tip:'提示',
    },
    //设备相关
    device:{
      sn:'SN',
      dvc_type:'设备型号',
      tid:'TID',
      deviceStatus:'设备状态',
      status:'状态',
      property_agency:'产权机构',
      lastOnlineTime:'最后在线时间',
      queryLastOnlineTime:'最后在线时间',
      selectLastOnlineTime:'请选择最后在线时间',
      device_task:'设备任务',
      device_task_log_0:'终端任务日志',
      list_detail:'详情',
      operation:'操作',
      scan:'查看',
      scan_details:'查看详情',
      update_key:'更新秘钥',
      update_title:'更新秘钥',
      update_tip:'您确定更新秘钥吗?',
      update_key_success:'密钥更新成功',
      to_order:'指令性操作',
      manufacturer_name:'厂商',
      query_dvc_type:'机型',
      mid:'MID',
      utms_sn:'SN',
      sysVersion: 'OS版本',
      seVersion: 'SE版本',
      ufsVersion: 'UFS版本',
      query_condition:'筛选条件',
      device_list_count:'设备列表  共',
      tai:'台',
      last_address:'地理位置',
      export_btn:'导出',
      export_file_name:'设备列表',
      query:'查询',
      reset:'重置',
      device_tab_device_detail:'设备详情',
      device_tab_latest_upload_time:'最后上报时间：',
      device_tab_power:'电量',
      device_tab_power_consumption:'耗电情况',
      device_tab_device_apps:'设备应用',
      device_hardware_detection:'硬件检测',
      detection_time:'检测日期',
      detection_result:'检测结果',
      detection_exception:'异常项',
      exception_item:'异常',
      skip_item:'跳过',
      icc_exception:'ICC',
      mag_exception:'MAG',
      picc_exception:'PICC',
      printer_exception:'打印机',
      scanner_exception:'扫描头',
      frontCamera_exception:'前置摄像头',
      rearCamera_exception:'后置摄像头',
      detection_ok:'健康',
      detection_no:'异常',
      detection_normal:'正常',

      hardware_detection:'硬件检测',
      test_results:'检测结果',
      test_results_details:'检测结果详情',
      test_results_1:'共检测 ',
      test_results_item:' 项',
      test_results_2:'通过 ',
      test_results_3:'跳过 ',
      test_results_4:'异常 ',



      device_no:'SN号',
      device_type:'机型',
      pre_card:'预装卡',
      sim_card_no:'SIM卡号',
      sim_serious_no:'SIM序列号',
      current_sim_master:'当前主卡',
      current_sim_secondary:'当前副卡',
      flash_id:'Flash ID',
      ip:'IP',
      option:'操作',
      download_log_file:'下载设备日志',
      sim_operator:'运营商',
      android_version:'Android版本',
      ram_dosage:'RAM用量',
      rom_dosage:'ROM总量',
      data_flow:'数据流量',
      data_wifi_flow:'WIFI流量',
      data_sim1_flow:'SIM1流量',
      data_sim2_flow:'SIM2流量',
      used:'已用',
      remain:'剩余',
      app_name:'应用名',
      app_version_name:'版本名',
      app_version_code:'版本号',
      app_package:'包名',
      app_size:'大小',
      system_app:'系统应用',
      third_app:'第三方应用',



      //指令相关
      order_device_operate:'设备操作',
      order_operate_los:'操作日志',
      operate_content:'操作内容',
      operate_time:'操作时间',
      operator:'操作人',
      browser:'浏览器',
      disable:'禁用',
      enable:'解禁',
      disableBtn:'禁用',
      enableBtn:'启用',
      shutdown:'关机',
      restart:'重启',
      ring:'设备响铃',
      ring_pwd:'密码',
      ring_modal_total:'温馨提示',
      ring_modal_total1:'设备将以最大铃声响铃，可通过输入密码退出。',
      ring_modal_total2:'退出响铃密码',
      ring_modal_total3:'请输入4位数字',
      ring_modal_total_true:'是',
      ring_modal_total_false:'否',
      device_reset:'恢复出厂设置',
      get_device_logs:'提取设备日志',
      remote_desk:'远程桌面',
      clear_oprate : '清除锁屏密码',
      clp_tip : '清除密码后不会导致应用数据丢失，但密码将无法恢复，是否继续？',
      confirm:'确定',
      cancel:'取消',
      device_img:'设备',
      device_info:'设备信息',
      device_status:'设备状态',
      on_line:'在线',
      off_line:'离线',
      failReason:'失败原因',
      msg_status_publish_col: '最近消息状态',
      msg_status_publish_time: '推送时间',
      msg_status_publish_status: '消息状态',
      msg_status_publish: '发送中',
      msg_status_delivered: '在途',
      msg_status_acked: '到达',
      msg_status_dropped: '丢弃',
      on_work:'正常',
      disable_tip:' 此操作将会禁用设备, 是否继续?',
      enable_tip:' 此操作将会解禁设备, 是否继续?',

      shutdown_tip:'此操作将会使设备关机，是否继续?',
      restart_tip:'此操作将会使设备重启，是否继续?',
      ring_tip:'此操作将会使设备响铃，是否继续?',
      reset_tip:'此操作将会使设备恢复出厂设置，是否继续?',
      get_log_tip:'此操作将会提取设备日志，是否继续?',
      remote_desk_tip:'此操作将会启动设备远程桌面，是否继续?',
      close:'关闭',
      remote_desk_request_expired:'远程桌面请求已过期，请重新发送',
      remote_desk_fail_reason:'远程桌面故障，原因是',
      task_code:'任务编号',
      task_type:'类型',
      task_name:'内容',
      task_status:'执行状态',
      release_time:'下发时间',
      execution_time:'执行时间',
      app_deploy:'应用部署',
      wifi_config:'WIFI配置',
      apn_config:'APN配置',
      function_config:'功能设置',
      param_config:'参数配置',
      file_distribution:'文件分发',
      message_send:'消息推送',
      fence_config:'地理围栏',
      custom_desktop:'自定义桌面',
      get_device_log:'提取设备日志',
      occupy_screen_log:'霸屏应用',
      boot_animation:'开机动画',
      app_whitelist:'应用白名单',
      wifi_whitelist:'WIFI白名单',
      auto_start_app:'默启应用',
      app_uninstall:'应用卸载',
      policy_management:'策略管理',
      app_black_list:'应用黑名单',
      lock_screen_password:'锁屏密码',
      Advertisement: '广告推送',

      task_executing:'执行中',
      task_executing_fail:'执行失败',
      task_executing_success:'执行成功',
      org_name:'商户',
      device_task_log:'终端任务日志',

      //电量相关
      power_mobile_network:'移动网络待机',
      power_screen:'屏幕',
      power_blueTooth:'蓝牙',
      power_system:'系统',
      phone_standby_power:'手机待机',
      power_wifi:'WIFI',
      current_power:'当前电量:',
      power_consumption_ratio:'耗电比例',
      power_consumption:'耗电',
      acquisition_time:'采集时间',
      power_recharge:'充电',
      power_discharge:'放电',
      device_power:'电量',
      device_power_update_time:'更新时间',

      device_type_no_select:'请选择机型',
      device_position_info:'位置信息',
      device_location:'设备位置',
      device_historical_track:'历史轨迹',
      historical_track_start_date:'开始日期',
      historical_track_end_date:'结束日期',
      historical_track_map_mode:'地图模式',
      historical_track_data_mode:'数据模式',
      data_mode_table_column_time:'时间',
      data_mode_table_column_longitude:'经度',
      data_mode_table_column_latitude:'纬度',
      data_mode_table_column_position:'地理位置',
      historical_track_select_date_tip:'请选择时间范围',
      historical_track_time:'时间',
      current_location:'当前位置',
      last_location:'上次位置'
    },
    manufacturer:{
      addManufacturer:'新增厂商',
      confirm:'确定',
      cancel:'取消',
      enter_manufacturer_name:'最大100个字符',
      enter_manufacturer_dvc_type:'最大25个字符',
      remove_manufacturer_type_tip1:'确定要删除',
      remove_manufacturer_type_tip2:'型号吗？',

      remove_manufacturer_tip1:'确定要删除',
      manufacture_name_empty:'厂商不能为空',
      dvc_type_empty:'设备类型不能为空',
      manufacturer_name:'厂商名称:',
      dvc_type:'设备型号:',



    },

    flowManage:{
      flowUsage:'流量使用情况',
      appRank:'应用排行',
      groupRank:'机构商户排行',
      exportReport:'导出报表',
      date:'日期',
      start_date:'开始日期',
      end_date:'结束日期',
      totalUsage:'总消耗流量',
      dayUsagePerDvc:'每台设备日均流量',
      rank:'排行',
      org:'机构',
      parentOrg:'所属父机构',
      percent:'占比',
      operate:'操作',
      appName:'应用名称',
      appPackage: '应用包名',
      periodTotalFlow:'期间总流量',
      dvcNum:'设备数',
      periodDayFlow:'期间日均流量',
      dvcDayFlow:'每台设备日均流量',
      periodOrgFlowUsage:'所选机构期间设备的流量使用情况',
      periodAppFlowUsageRank:'期间该设备应用使用流量排行',
      dvcSnCode:'设备SN号',
      selectOrg:'请选择机构',
      unitMb:'单位：Mb',
      selectRankOrg:'选择进行排行的机构',
      groupTip:'提示：数据包含该机构及其子机构以下的所有设备',
      childGroupUsageDetail:'子机构流量详情',
      currentOrg:'当前机构',
      selectTwoMoreOrg:'勾选的机构不得少于2个',
      nought:'无',
      allOrg:'全部机构',
      selectDay:'请选择日期',
      startDayBeforeEndDay:'开始日期不能大于结束日期',

      flowLimitWarn:"限额提醒",
      flowLimit:{
        tip: {
          search_tip: "请输入SN",
        },
        modal:{
          flow_limit_tip:"流量限额提醒",
          limit_tip:"当天流量消耗超过设定值时，记录并警示，每日可将前一天设备总体警示信息发送至指定邮箱",
          limited_amount_day:"当天限定额度",
          subscription_report:"订阅日报",
          send_daily:"发送日报",
          not_send_daily:"不发送日报",
          report_tip:"(每天09:00发送昨天的数据)",
          receive_mailbox:"接收邮箱",
          limit_error_tip:"请输入1~9999之间的整数",
        },
        button:{
          limit_setting:"限额设置",
        },
        table:{
          sn:"SN",
          operate:"操作",
          record_time:"记录时间",
          flow_use:"当天流量使用量",
          flow_limit:"当天限定额度",
          warn:"警告",
          warn_tip:"流量已达上限",
        },
      },
    },

    platformSetting:{
      data_cache_setting:'数据缓存设置',
      data_cache_setting_power_clean:'电量信息有效期',
      data_cache_setting_address_clean:'位置信息有效期',
      data_cache_setting_log_clean:'操作日志有效期',
      data_cache_setting_app_clean:'应用信息有效期',
      data_cache_setting_power_cache:'电量获取频率',
      data_cache_setting_day:'天',
      data_cache_setting_minute:'分钟',
      data_cache_setting_error_tip:'数据缓存设置中天数必须为正整数且不能大于30',
      data_cache_setting_power_error_tip:'电量信息有效期范围为1-360天',
      data_cache_setting_power_error_tip_empty:'电量信息有效期不能为空',
      data_cache_setting_log_error_tip:'操作日志有效期范围为30-360天',
      data_cache_setting_power_cache_frequency:'电量信息缓存频率只能输入整数且不能超过24小时（即1440分钟）',
      data_cache_setting_net_connect:'网络连接信息缓存频率只能输入整数且不能超过24小时（即1440分钟）',
      data_cache_setting_log_error_tip_empty:'操作日志有效期不能为空',
      platform_setting:'安全设置',
      platform_setting_tip:'密码尝试次数',
      platform_setting_time:'次',
      platform_setting_submit:'应用',
    },
    logManage:{
      log_add:"新建日志任务",
      log_query:"查询",
      sn:"SN",
      sn_tip:"请输入SN",

      device_type:"机型",
      device_type_tip:"请选择机型",

      task_time:"任务时间",
      task_time_tip:"请选择时间范围",

      status:"状态",
      status_tip:"请选择状态",

      status_finish:"已完成",
      status_push:"推送中",
      status_execution:"执行中",
      status_no_response:"终端无响应",
      status_forced_stop:"强制终止",
      status_file_is_not_exists:"文件不存在",

      operate_download_log:"下载日志",
      operate_reset:"重试",
      operate_force_stop:"终止操作",

      table_sn:"SN",
      table_device_type:"机型",
      table_remark:"设备备注",
      table_log_type:"日志类型",
      table_create_time:"创建时间",
      table_start_time:"开始时间",
      table_end_time:"结束时间",
      table_status:"状态",
      table_operate:"操作",
      log_file_path:"文件路径",
      log_type_utms:"UTMS日志",
      log_type_system:"系统日志",
      log_type_file:"指定文件",
      log_type_utms_path:"/sdcard/UTMS/Log",
      log_type_system_path:"/sdcard/Ulog/logs/adb",
      log_type_target_path:"根据目标路径显示",
      log_type_utms_tip_1:"此操作将要提取设备日志，是否继续？",
      log_type_utms_tip_2:"日志文件上传需要一定时间，完成后，在日志记录中下载。",

      log_type_system_start_time:"开始时间",
      log_type_system_continued_time:"持续时间",
      log_type_system_record_log:"记录日志",
      log_type_system_log_main:"main日志",
      log_type_system_log_main_tip:"(内核及root权限操作日志)",
      log_type_system_log_radio:"radio日志",
      log_type_system_log_radio_tip:"(射频通讯模块通讯日志)",
      log_type_system_log_system:"system日志",
      log_type_system_log_system_tip:"(操作系统日志)",
      log_type_system_log_events:"events日志",
      log_type_system_log_events_tip:"(事件日志，例触屏点击事件等)",
      log_type_system_file_size:"文件限制",
      log_type_system_file_rule:"文件规则",
      log_type_system_file_rule_1:"上传后删除文件",
      log_type_system_file_rule_2:"上传后通知设备",

      log_type_system_start_time_type_tip:"请选择开始时间",
      log_type_system_continued_time_tip:"请输入持续时间",
      log_type_system_continued_time_tip1:"持续时间必须在1-100之间",
      log_type_system_continued_time_tip2:"请选择时间单位",
      log_type_system_record_log_tip:"请勾选日志记录类别",
      log_type_system_file_size_tip:"请输入文件限制",
      log_type_system_file_size_tip1:"文件限制必须在0-200之间",

      log_type_file_path:"目标路径",
      log_type_file_path_format:'格式如:/sdcard/MDM',
      log_type_file_path_tip:"如上为设备端文件存储的指定路径",
      log_type_file_file_rule:"文件规则",
      log_type_file_file_rule_1:"上传后删除文件",

      log_type_file_path_error_tip:"请输入目标路径",
      log_type_file_path_error_tip1:"目标路径不合法,请输入合法路径",

      log_time_min:"分",
      log_time_hour:"小时",
      log_time_day:"天",


      add_table_sn:"SN",
      add_table_device_type:"机型",
      add_table_status:"状态",

      add_table_add_tip:"请在左侧表格选择数据",
      add_table_remove_tip:"请在右侧表格选择数据",

      modal_add_log:"提取设备日志",
      modal_select_device:"选择设备",
      modal_log_task:"日志任务",

      modal_button_add:"添加",
      modal_button_delete:"移除",
      modal_button_cancel:"取消",
      modal_button_next:"下一步",
      modal_button_sure:"确定",

      device_status_on:"在线",
      device_status_off:"离线",

      modal_tip_select_dvcId_empty:"选择设备数为空",

      tip:"提示",
      tip_content_forced_stop:"此操作将停止采集日志，是否继续?",
      tip_content_reset:"此操作将重新推送日志采集，是否继续?",

      log_download:'下载',
    },
    configureManage:{
      button:{
        upload_config:'上传配置',
        generate_barcode:'生成条码',
        publish:"发布",
        delete_config:"删除",
        cancel:"取消",
        save:"确定",
      },
      table:{
        table_name:'配置管理',
        configName:'配置名称',
        configRuleType:"配置类型",
        version:"规则版本号",
        pushType:"推送范围",
        pushStatus:"状态",
        executionProgress:"执行进度",
        createTime:"创建时间",
        updateTime:"上次修改时间",

      },

      type:{
        scan_head:'扫描头设置',
        system:'系统设置',
        scan_and_system:'扫描头设置和系统设置',
      },
      status:{
        pushed:'已发布',
        not_pushed:'未发布',
        terminate_pushed:'终止发布',
      },
      modal:{
        head:'上传配置',
        barcode_generate:'条码生成',
        upload_file:'上传配置文件',
        upload_file_tip:'支持文件格式: txt',
        upload_file_format_tip:'上传文件格式错误,请上传txt格式文件',
        upload_file_size_tip:'请上传小于100KB的txt文件',
        barcode_tip:'打开终端U stage扫描二维码下配置文件',
        barcode_down:'下载二维码到本地',
        tip:"提示",
        delete_tip:"您将删除选择的配置，是否继续?",
      },
      tip:{
        select_one_row:"请选择一条规则",
        select_more_one_row:"仅可选择一条规则",
        select_delete_row:"请选择需要删除的数据",
        add_tip:"请上传配置文件",
        top_tip_1:"1、 上传配置：使用终端应用：UStage - 导出配置文件（UStage可通过应用市场上架并下载），将此配置文件上传。使用上传配置可通过UTMS发布，终端联网后自动下载并生效配置。",
        top_tip_2:"2、 终端上传：使用终端应用：UStage - 上传至UTMS，可同步该设备的配置到UTMS后台。使用终端上传，会自动生成一条规则，可通过UTMS发布。",
      }
    },

  },
  device: {
    messagetype: {
      all : '全部',
      inbox:'接收',
      sent : '发送',
      draft:'草稿',
      outbox:'发件箱',
      failed: '发送失败',
      queued:'待发送'
    },
    calltype: {
      incoming:'呼入',
      outgoing:'呼出',
      missed:'未接',
      voicemail:'语音信箱',
      rejected:'拒接',
      blocked:'黑名单',
      answeredexternally:'来点转接'
    }
  },
  time:{
    year0:'年',
    month0:'月',
    day0:'天',
    hour0:'小时',
    min0:'分',
    sec0:'秒'
  },
  alert:{
    msg0:'提示',
    confirm0:'确认',
    cancel0:'取消',
    appRepet1:'对不起！你上传的APK',
    appRepet2:'已存在。',
    appRepet3:'如此应用确实为贵公司所有，请发邮件到',
    appRepetMail:"uhome{'@'}urovo.com",
    appRepet3_1:'认领应用。认领成功后，该应用会转入您的名下，并保留完整数据。',
    appRepet4:'同名应用：',
    appRepet5:'认领邮件格式：',
    appRepet6:'标题：认领应用',
    appRepet7:'邮件正文：认领应用-同名应用(包名)，联系人，联系方式。并附件中添加公司营业执照，对应软件著作权证明等。',
  },

  //elementui 国际化属性覆盖
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  },

  //国家/地区
  area:{
    Angola:'安哥拉',
    Afghanistan:'阿富汗',
    Albania:'阿尔巴尼亚',
    Algeria:'阿尔及利亚',
    Andorra:'安道尔共和国',
    Anguilla:'安圭拉岛',
    Antigua_and_Barbuda:'安提瓜和巴布达',
    Argentina:'阿根廷',
    Armenia:'亚美尼亚',
    Ascension:'阿森松',
    Australia:'澳大利亚',
    Austria:'奥地利',
    Azerbaijan:'阿塞拜疆',
    Bahamas:'巴哈马',
    Bahrain:'巴林',
    Bangladesh:'孟加拉国',
    Barbados:'巴巴多斯',
    Belarus:'白俄罗斯',
    Belgium:'比利时',
    Belize:'伯利兹',
    Benin:'贝宁',
    Bermuda_Is:'百慕大群岛',
    Bolivia:'玻利维亚',
    Botswana:'博茨瓦纳',
    Brazil:'巴西',

    Brunei:"文莱",
    Bulgaria:"保加利亚",
    Burkina_Faso:"布基纳法索",
    Burma:"缅甸",
    Burundi:"布隆迪",
    Cameroon:"喀麦隆",
    Canada:"加拿大",
    Cayman_Is :"开曼群岛",
    Central_African_Republic:"中非共和国",
    Chad:"乍得",
    Chile:"智利",
    China:"中国",
    Colombia:"哥伦比亚",
    Congo:"刚果",
    Cook_Is:"库克群岛",
    Costa_Rica:"哥斯达黎加",
    Cuba:"古巴",
    Cyprus:"塞浦路斯",
    Czech_Republic:"捷克",
    Denmark:"丹麦",
    Djibouti:"吉布提",
    Dominica_Rep:"多米尼加共和国",
    Ecuador:"厄瓜多尔",
    Egypt:"埃及",
    EI_Salvador:"萨尔瓦多",
    Estonia:"爱沙尼亚",
    Ethiopia:"埃塞俄比亚",
    Fiji:"斐济",
    Finland:"芬兰",
    France:"法国",
    French_Guiana:"法属圭亚那",
    French_Polynesia:"法属玻利尼西亚",
    Gabon:"加蓬",
    Gambia:"冈比亚",
    Georgia:"格鲁吉亚",
    Germany:"德国",
    Ghana:"加纳",
    Gibraltar:"直布罗陀",
    Greece:"希腊",
    Grenada:"格林纳达",
    Guam:"关岛",
    Guatemala:"危地马拉",
    Guinea:"几内亚",
    Guyana:"圭亚那",
    Haiti:"海地",
    Honduras:"洪都拉斯",
    Hungary:"匈牙利",
    Iceland:"冰岛",
    India:"印度",
    Indonesia:"印度尼西亚",
    Iran:"伊朗",
    Iraq:"伊拉克",
    Ireland:"爱尔兰",
    Israel:"以色列",
    Italy:"意大利",
    Ivory_Coast:"科特迪瓦",
    Jamaica:"牙买加",
    Japan:"日本",
    Jordan:"约旦",
    Kampuchea:"柬埔寨",
    Kazakstan:"哈萨克斯坦",
    Kenya:"肯尼亚",
    Korea:"韩国",
    Kuwait:"科威特",
    Kyrgyzstan:"吉尔吉斯坦",
    Laos:"老挝",
    Latvia:"拉脱维亚",
    Lebanon:"黎巴嫩",
    Lesotho:"莱索托",
    Liberia:"利比里亚",
    Libya:"利比亚",
    Liechtenstein:"列支敦士登",
    Lithuania:"立陶宛",
    Luxembourg:"卢森堡",
    Madagascar:"马达加斯加",
    Malawi:"马拉维",
    Malaysia:"马来西亚",
    Maldives:"马尔代夫",
    Mali:"马里",
    Malta:"马耳他",
    Mariana_Is:"马里亚那群岛",
    Martinique:"马提尼克",
    Mauritius:"毛里求斯",
    Mexico:"墨西哥",
    Moldova:"摩尔多瓦",
    Monaco:"摩纳哥",
    Mongolia:"蒙古",
    Montserrat_Is:"蒙特塞拉特岛",
    Morocco:"摩洛哥",
    Mozambique:"莫桑比克",
    Namibia:"纳米比亚",
    Nauru:"瑙鲁",
    Nepal:"尼泊尔",
    Netheriands_Antilles:"荷属安的列斯",
    Netherlands:"荷兰",
    New_Zealand:"新西兰",
    Nicaragua:"尼加拉瓜",
    Niger:"尼日尔",
    Nigeria:"尼日利亚",
    North_Korea:"朝鲜",
    Norway:"挪威",
    Oman:"阿曼",
    Pakistan:"巴基斯坦",
    Panama:"巴拿马",
    Papua_New_Cuinea:"巴布亚新几内亚",
    Paraguay:"巴拉圭",
    Peru:"秘鲁",
    Philippines:"菲律宾",
    Poland:"波兰",
    Portugal:"葡萄牙",
    Puerto_Rico:"波多黎各",
    Qatar:"卡塔尔",
    Reunion:"留尼旺",
    Romania:"罗马尼亚",
    Russia:"俄罗斯",
    Saint_Lueia:"圣卢西亚",
    Saint_Vincent:"圣文森特岛",
    Samoa_Eastern:"东萨摩亚(美)",
    Samoa_Western:"西萨摩亚",
    San_Marino:"圣马力诺",
    Sao_Tome_and_Principe:"圣多美和普林西比",
    Saudi_Arabia:"沙特阿拉伯",
    Senegal:"塞内加尔",
    Seychelles:"塞舌尔",
    Sierra_Leone:"塞拉利昂",
    Singapore:"新加坡",
    Slovakia:"斯洛伐克",
    Slovenia:"斯洛文尼亚",
    Solomon_Is:"所罗门群岛",
    Somali:"索马里",
    South_Africa:"南非",
    Spain:"西班牙",
    SriLanka:"斯里兰卡",
    St_Lucia:"圣卢西亚",
    St_Vincent:"圣文森特",
    Sudan:"苏丹",
    Suriname:"苏里南",
    Swaziland:"斯威士兰",
    Sweden:"瑞典",
    Switzerland:"瑞士",
    Syria:"叙利亚",
    Tajikstan:"塔吉克斯坦",
    Tanzania:"坦桑尼亚",
    Thailand:"泰国",
    Togo:"多哥",
    Tonga:"汤加",
    Trinidad_and_Tobago:"特立尼达和多巴哥",
    Tunisia:"突尼斯",
    Turkey:"土耳其",
    Turkmenistan:"土库曼斯坦",
    Uganda:"乌干达",
    Ukraine:"乌克兰",
    United_Arab_Emirates:"阿拉伯联合酋长国",
    United_Kiongdom:"英国",
    United_States_of_America:"美国",
    Uruguay:"乌拉圭",
    Uzbekistan:"乌兹别克斯坦",
    Venezuela:"委内瑞拉",
    Vietnam:"越南",
    Yemen:"也门",
    Yugoslavia:"南斯拉夫",
    Zimbabwe:"津巴布韦",
    Zaire:"扎伊尔",
    Zambia:"赞比亚",
  },

  // 机构相关
  org: {
    orgTree: {
      title_create: '创建子机构（商户）',
      placeholder_filter: '请输入机构或商户名',
      check_box_inter: '父子联动',
      check_box_inter1: '全选',
      form_superiorOrgName: '上级机构：',
      form_orgType: '机构类型：',
      form_orgType_SubOrganization: '子机构',
      form_orgType_Merchant: '商户',
      form_orgName: '机构(商户)名称：',
      form_orgName_placeholder: '请输入机构(商户)',
      form_merchant_placeholder: '请输入Merchant ID',
      form_admin_email: '管理员邮箱：',
      form_admin_email_help: "此账号可以登录商户终端管理平台，默认密码为：",
      form_admin_email_placeholder: '请输入管理邮箱',
      form_contactsName: '联系人：',
      form_contactsName_placeholder: '请输入联系人名称',
      form_contacts_phone: '联系电话：',
      form_contacts_phone_placeholder: '请输入联系电话：',
      form_address: '商户地址：',
      form_address_placeholder: '请输入商户地址',
      form_remarks: '备注：',
      form_remarks_placeholder: '请输入备注',
      form_btn_create: '创建',
      form_btn_cancel: '取消',

      validate_msg_orgName: '请输入子机构（商户）名称',
      validate_msg_orgName_too_long: '子机构（商户）名长度不能超过125位',
      validate_msg_email: '管理员邮箱不符合规范，请重新输入',
      validate_msg_email_required: '请输入邮箱地址',
      validate_msg_merId: 'Merchant ID 长度不能超过32位',
      validate_msg_contactsName: '联系人名称不能超过100位',
      validate_msg_contactsPhone: '请输入正确的电话格式',
      validate_msg_address: '商户地址长度不能超过100个字符',
      validate_msg_remarks: '备注长度不能超过100个字符',

      add_org_success: '新增机构（商户）成功',

      detail_form_title: '机构详情',
      detail_form_title_merchant: '商户详情',
      detail_form_bind_device: '已绑定设备',
      detail_form_storage_device: '终端仓库设备',
      detail_form_orgName: '机构名称：',
      detail_form_orgName_placeholder: '请输入机构名称',
      detail_form_merchantName: '商户名称：',
      detail_form_merchantName_placeholder: '请输入商户名称',
      detail_form_btn_save: '保存',
      detail_form_btn_delete_org: '删除机构',
      detail_form_btn_delete_merchant: '删除商户',
      detail_form_btn_create_child: '新建下级组织',

      detail_delete_error_title: '删除机构失败',
      detail_delete_error_title_2: '删除商户失败',
      detail_delete_btn_ok: '确定',
      detail_delete_warning: '提示',
      detail_delete_msg_one: '删除机构(商户)：',
      detail_delete_msg_two: '，该机构(商户)内设备所有配置清空，自动解除绑定，移动到上一级设备仓库，确认删除？',
      detail_delete_btn_confirm: '删除',
      detail_delete_btn_cancel: '取消',

      detail_delete_success: '删除操作成功',
      detail_update_success: '修改操作成功',

      excel_btn_upload: '批量导入',
      excel_title_upload: '批量导入机构（商户）',
      excel_check_clear: '覆盖重复数据',
      excel_download_excel: '下载Excel模板',
      excel_tips_upload: '拖动文件或者点击此处上传',
      excel_btn_cancel: '取消',
      excel_title_error: '批量导入失败',
      excel_btn_ok: '确定',

      excel_table_rowAndCol: '行列号',
      excel_table_reason: '错误原因',

      excel_table_title_1: '批量解绑设备',
      excel_table_column_sn: 'SN',
      excel_table_column_time: '绑定时间',
      excel_table_column_orgName: '机构名称',

      btn_batch_unbind: '全部解绑',
      btn_batch_cancel: '取消',
      excel_download_template: '下载模板',

      modal_batch_unbind_title: '警告',
      modal_batch_unbind_btn_confirm: '确定',
      modal_batch_unbind_msg: '设备解除绑定后，将删除所有设备数据，请谨慎操作。',
    },
    expendRow: {
      dvcType: '机型:',
      orgAndMerchant: '商户/机构:',
      status: '状态:',
      status_normal: '正常',
      status_forbidden: '禁用',
      push_org: '分组推送',
      push_sn: 'TID/SN推送',
      config_valid: '生效',
      config_invalid: '不生效',
      delete_row: '删除',
      delete_column: '删除',
      delete_warnning: '提示',
      placeholder: '请输搜索关键字',
      btn_add: '添加',
      btn_batch: '批量导入',
      table_row_operation: '操作',
    }
  },
  // 设备仓库相关
  deviceRepository: {
    search: {
      manufacturer_name: '厂商：',
      manufacturer_name_placeholder: '请选择厂商',
      device_type: '机型：',
      device_sn: 'SN：',
      device_sn_placeholder: '请输入SN号进行查询',
      device_type_placeholder: '请选择机型',
      add_time: '入库时间：',
      add_time_bind: '绑定时间：',
      add_time_placeholder: '请选择日期',
      btn_search: '查询',
    },
    add: {
      btn_add_one: '单件入库',
      modal_add_one: '单件入库',
      form_org_name: '所属机构：',
      form_manufacturer_name: '设备厂商：',
      form_manufacturer_name_placeholder: '请选择设备厂商',
      form_device_type: '设备类型：',
      form_device_type_placeholder: '请选择设备类型',
      form_device_sn: 'SN：',
      form_device_sn_placeholder: '请输入SN号',
      form_device_tid: 'TID：',
      form_device_tid_placeholder: '请输入TID',
      form_device_remark: '备注：',
      form_device_remark_placeholder: '请输入备注',
      form_btn_add: '入库',
      form_btn_cancel: '取消',

      validate_sn: '请输入设备SN号',
      validate_sn_too_long: '设备SN号长度不超过50位',
      validate_tid_too_long: 'tid长度不超过50位',
      validate_remark_too_long: '备注长度不超过300位',
      validate_manufacture: '请选择设备厂商',
      validate_device_type: '请选择设备型号',

      add_success: '单件入库成功',
    },
    table: {
      storage_time: '入库时间',
      bind_time: '绑定时间',
      manufacturer_name: '设备厂商',
      device_type: '设备类型',
      operator: '操作人',
      remark: '备注信息',
    },
    bash: {
      btn_bash_storage: '批量入库',
      modal_title_bash_storage: '批量入库',
      modal_btn_download: '下载模板',
      modal_tips_upload: '拖动Excel文件或者点击此处上传',
      excel_title_file_error: '请导入.xls的Excel文件',
      modal_btn_cancel: '取消',
      excel_title_error: '批量导入失败',
      excel_btn_ok: '确定',
      excel_msg_success: '操作成功',
    },
    storageMove: {
      btn: '库存移动',
      btn1: '批量移库',
      modal_title: '移动库存到',
      modal_title1: '批量移库到',
      modal_btn_move: '移动',
      modal_btn_cancel: '取消',
      modal_success: '库存移动操作成功',
    },
    deviceBind: {
      btn: '设备绑定',
      btn1: '批量绑定',
      modal_title: '绑定设备到',
      modal_btn_bind: '绑定',
      modal_btn_cancel: '取消',
      modal_btn_next: '下一步',
      modal_btn_pre: '上一步',
      modal_step_1: '完善设备信息(可选)',
      modal_step_2: '选择绑定主体',
      modal_success: '设备绑定成功',
    },
    deviceUnbind: {
      btn: '设备解绑',
      tip: '提示',
      tip_msg: '解绑设备，会导致设备所有配置清空，移动到设备仓库，确认解除绑定？',
      btn_unbind: '解绑',
      btn_cancel: '取消',
      success_msg: '解绑操作成功',
    },
    deviceDelete: {
      btn: '设备删除',
      btn1: '批量删除',
      tip: '提示',
      tip_msg: '删除设备，则设备将从系统中移除，确认删除设备？',
      btn_delete: '删除',
      btn_cancel: '取消',
      success_msg: '删除操作成功',
      fail_msg: '删除操作失败',
    }
  },
  //应用相关
  app:{
    list:{
      no_select:'请至少选择一个应用',
      no_select_org:'请勾选需要上架的机构！'
    },
    check :{
      auto_mode:'自动审核',
      manual_mode:'人工审核',
      wait_check:'待审核',
      pass_check:'通过',
      refuse_check:'不通过',
      oprate_tip:'提示',
      add_balcklist_tip:'是否添加到审核黑名单？',
      check_mode:'审核模式',
      view_black_list:'查看黑名单',
      check_progress:'审核进度',
      putin_app_name:'请输入应用名称',
      search:'搜索',
      app_name:'应用名称',
      app_version_code:'应用版本',
      app_version_name:'版本名称',
      sign_mode:'签名方式',
      submit_user:'提交用户',
      submit_time:'提交时间',
      progress:'进度',
      operate:'操作',
      sign_no:'原生',
      sign_yes:'签名',
      no_pass_check:'不通过',
      app_package:'应用包名',
      remove_app_blacklist:'移出黑名单',
      no_pass_tip:'审核结果: 应用审核不通过！',
      fail_reason:'失败原因:',
      no_check:'未审核',
      ing_check:'审核中',
      check_pass:'审核通过',
      click_icon_tip:'点击图标可编辑应用信息',
      app_in_version:'版本',
      check_no_pass:'审核不通过',
      app_download:'下载',
      apply_push:'申请发布',
      cancel_apply:'取消申请',
      wait_check_tip:'审核需要3-5个工作日，请耐心等待！',
      push_apply_confirmation:'发布申请确认',
      apply_confirmation_tip:'发布申请后，审核需要3-5个工作日，请耐心等待。',
      cancel_check_apply:'撤回审核申请',
      cancel_apply_tip:'应用正等待管理员审核，是否撤回申请？',
      re_apply_check:'重新申请',
      re_apply_confirmation:'是否对此应用再次申请审核？',
      has_shelf_app:'已上架应用',
      app_unshelf:'应用下架',
      no_shelf_app:'未上架应用',
      app_shelf:'应用上架',
      app_detail:'详情',
      app_version:'版本',
      app_shelf_org:'分组上架',
      app_org_select:'分组选择',
      add_inside_app:'新增应用',
      file_size:'应用大小',
      eidt:'编辑',
      version_history:'版本',
      update:'更新',
      app_version_note:'版本说明',
      delete:'删除',
      version_update:'版本更新',
      select_busstype:'请选择行业类型',
      putin_app_check_note:'请输入审核意见',
      detail:'详情',
      to_blacklist:'加入黑名单',
      download:'下载',
      copy_tip:'确认要克隆此应用配置吗？',
      app_in_blacklist:'应用已加入黑名单',
      app_out_blacklist:'应用已移出黑名单，请重新申请审核',
      type_chage:'开启自动审核后所有应用申请都会自动通过，请谨慎选择！',
      to_auto:'是否开启自动审核？',
      to_handle:'是否开启人工审核？',
      select_apk:'请点击此处上传apk格式文件',
    },
    permissions:{
      no:'抱歉，您没有此操作权限！',
    },
  },
  //应用部署相关
  appdeploy:{
    add:{
      tip:'选择需要部署的应用',
      version:'版本:',
    },
    del:{
      del:'删除',
      tip1:'删除确认',
      tip2:'您将删除此配置，是否继续？',
      cacel:'取消',
      submit:'删除',
    },
    table:{
      progress:'完成状态',
      operate:'操作',
      nopush:'未推送',
      yespush:'已推送',
      record:'记录',
      allpush:'全部推送',
      partpush:'部分推送',
      inputorgname:'请输入机构名称查询',
    },
    push:{
      push:'推送',
      cancel:'取消',
    },
    copy:{
      copy:'克隆',
      tip:'选择需要部署的应用',
      version:'版本:',
    },
    details:{
      details:'查看',
    },
    record:{
      view:'查看推送内容',
      version:'版本号',
      pushRange:'查看推送范围',
      name:'名称',
      user:'操作员',
      pushrange:'推送范围',
      time:'操作时间',
      operate:'操作',
    },
  },
  // 日志相关
  operationLog: {
    search: {
      operator: '操作人：',
      operator_placeholder: '请输入操作人',
      module: '菜单：',
      module_placeholder: '请选择菜单',
      businessType: '业务类型：',
      businessType_placeholder: '请选择业务类型',
      operateTime: '操作时间：',
      operateTime_placeholder: '请选择操作时间',
      handle_status: '操作结果：',
      handle_status_placeholder: '请选择操作结果',
      btn_search: '查询',
      btn_reset: '重置',
      operation_result_success: '成功',
      operation_result_fail: '失败',
    },
    table: {
      successful: '成功',
      failure: '失败',
      operator: '操作人',
      module: '菜单',
      businessType: '业务类型',
      operatorTime: '操作时间',
      content: '操作内容',
      result: '操作结果',
      result_succ: '成功',
      result_fail: '失败',
    }
  },
  // OTA相关
  ota: {
    paramManagement: {
      add:'新增OTA参数',
      codeType:'参数类型',
      codeId:'参数编码',
      codeValue:'参数值',
      createUser:'创建人',
      createDate:'创建时间',
      lastModifyUser:'更新人',
      lastModifyDate:'更新日期',
      operation:'操作',
      codeType_msg:'参数类型不能为空',
      codeValue_msg:'参数值不能为空',
      create_cancel:'取消',
      DEVTYPE:'设备类型',
      STANDARD:'定制类型',
      MODEL:'硬件配置',
      create_confirm:'确定',
      delete:'删除',
      delete_title:'删除确认',
      delete_tip:'您将删除选择的OTA参数，是否继续?',
    },
    menu: {
      add_os: '上传OS镜像',
      del_os: '删除OS镜像',
      refresh: '刷新',
      add_reg: '添加',
      update_reg: '修改',
      push:'推送',
      stop:'禁用',
      enable: '已推送',
      disable: '已禁用',
      toBePush: '待推送',
      download_template: '下载模板',
      records: '查看升级记录',
    },
    data:{
      selectSn: '输入或者选择SN号',
      msgStatus: '消息记录',
      yes: '是',
      no: '否',
      change_reg: '推送规则',
      push: '推送',
      change_status: '更改状态',
      status: '状态',
      os_id: 'OS编号',
      os_type: '系统类型',
      dev_type: '设备类型',
      records_os_type: 'OS 类型',
      model: '硬件配置',
      standard: '定制类型',
      os_version: '版本号',
      language: '语言',
      bag_type: '包类型',
      high_version: '基础版本',
      upload_date: '上传时间',
      isForce: '是否强制更新',
      isSilent: '是否静默更新',
      isImmediate: '是否立即更新',
      period: '更新时间段',
      remind: '更新提醒',
      remarks: '备注',
      osUrl: 'OS下载地址',
      chinese: '中文',
      english: '英文',
      change_status_success: '操作成功',
      change_status_failed: '操作失败',
      push_succcess: '已生效并推送',
      return_tip:'提示',
      return_msg:'确定返回吗？',
      clear_snRegMsg:'确认清空所有SN吗？',
      url: '下载地址',
    },
    addos:{
      version_rules:'版本规则',
      view_version_tips:'查看规则',
      upload:'版本升级',
      basic_os:'基础OS版本',
      basic_os_tip: '增量更新包需填写此项',
      upload_package: '上传包',
      upload_package_tip: '上传包（仅支持.zip格式）',
      complete_package: '完整更新包',
      incremental_package: '增量更新包',
      default: '默认',
      timePick: '时间段',
      datePick: '日期时间段',
      eg:'填写示例',
      save: '保存',
      clear: '清空',
      back: '返回',
      addos_success: '上传OS镜像成功',
      validate_success:'表单数据验证成功',
      validate_failed:'请检查输入的数据是否正确',
      osType_msg: '系统类型不能为空',
      devType_msg: '设备类型不能为空',
      model_msg: '硬件配置不能为空',
      standard_msg: '定制类型不能为空',
      osVersion_empty_msg: '版本不能为空',
      osVersion_msg: '版本格式有误,请输入(安卓版本.YY.MMDD.xx)格式!',
      osLanguage_msg: '语言不能为空',
      bagType_empty_msg: '更新包类型不能为空',
      path_empty_msg: '请选择文件',
      path_format_error_msg: '文件格式错误',
      highVersion_empty_msg: '增量更新包需填写基础OS版本',
      select_empty: '请选择',
      period_empty: '时间段不能为空',
      TimePick_format_error: '时间段格式有误',
      TimePick_size_error: '开始时间大于结束时间',
      DatePick_format_error: '日期时间段格式有误',
      remind_empty: '静默更新选择否时，需填写更新提醒!',
      osVersion_format_msg: '请先填写正确的版本号',
      basic_os_error: '基础OS版本必须低于OS版本号',
      //后端错误信息
      filename_notfound:'未找到文件名',
      file_format_error: '文件格式错误',
      empty_file: '更新包为空文件，无法导入',
      unzip_file_failed: '文件解压失败，请重新选择文件',
      upload_oss_failed: '文件上传OSS失败',
      file_transfer_failed: '文件转化失败',
      file_save_failed: '文件上传服务器失败',
      request_failed: '请求失败',
    },
    delos:{
      select_item: '请至少选择一项',
      delete_os: '删除OS镜像',
      confirmed_del:'确认删除',
      delete_success: '成功删除',
      item: '项',
    },
    snReg:{
      push_by_sn: '按SN推送',
      push_by_org: '按节点推送',
      input_sn: '请输入SN',
      add_sn: '添加',
      import_sn: '导入',
      back: '返回',
      save: '保存',
      selectAll: '全选',
      save_success: '保存成功',
      add_error_msg: '设备不在本机构下或不存在',
      clear: '清空',
      added_sn: '已添加的SN',
      num: '序号',
      action: '操作',
      delete: '删除',
      os_info: '当前OS信息',
      sn_reg: 'SN规则说明',
      sn_reg1: '*SN号必须为14位或23位',
      sn_reg2: '*14位SN的前8位为数字或字母，后6位为纯数字',
      sn_reg3: '*23位SN的开头必须为',
    },
    validateSN:{
      sn_format_error: '不符合规则',
      sn_duplicate: '重复',
      sn_validate: 'SN只能由字母和数字组成,且不能为空'
    },
    importSN:{
      import_file: '导入文件',
      select_file: '选择文件 (.txt文件)',
      tips1: '*只能上传.txt文件',
      tips2: '*建议每行填写一个SN',
      tips3: '*若一行填写多个，则用","隔开',
      fileMaxSize: '文件大小超出限制',
      fileUploadError: '文件上传出错',
      fileFormatError: '文件格式错误',
      import_success: '成功导入',
      item: '条',
      cancel: '取消'
    },
    records:{
      osVersion: 'OS版本号',
      updateResult: '升级结果',
      btnSearch: '查询',
      btnReset: '重置',
      btnBack: '返回',
      finishedTime: '升级完成时间',
      recordedTime: '记录时间',
      success: '成功',
      failed: '失败',
      failedRes: '失败原因'
    }
  },
  // 设备配置相关
  deviceConfig: {
    wifiConfig: {
      push_succcess: '推送成功',
      clone_tip_wifi: '提示',
      clone_content_wifi: '确定要克隆该配置吗？',
      tab_name: 'WIFI配置',
      deleteBash: {
        btn: '删除',
        modal_title: '批量删除配置',
        modal_tip: '删除这些配置，将同时在设备上清除这些配置，确认继续删除？',
        modal_tip1: '确认删除选定配置？',
        modal_app_param_tip:'是否要删除这些参数配置？',
        modal_btn_cancel: '取消',
        modal_btn_confirm: '删除',
      },
      addOne: {
        btn: '添加',
        btn1: '编辑',
        modal_title: '添加WIFI配置',
        modal_title1: '编辑WIFI配置',
        form_name: '配置名称',
        form_name_placeholder: '请输入配置名称',
        form_ssid: '服务集标识符（SSID）',
        form_ssid_tip:'要连接的WiFi名称',
        form_network_hide:'隐藏网络',
        form_network_hide_tip:'目标网络非开放网络或未广播信号时，请开启此功能',
        form_safeType:'安全类型',
        form_safeType_tip:'连接时使用的无线网络加密类型',
        form_password:'密码',
        form_password_tip:'无线网络密码',
        qr_code_generate_tip:'请填写设置信息后再生成二维码',
        qr_code_generate:'生成二维码',
        qr_code_generate_new_tip:'点击生成WIFI连接二维码，设备端可通过扫描二维码，连接对应的网络',
        form_btn_cancel:'取消',
        form_btn_confirm: '添加',
        form_btn_confirm1: '编辑',
        validate_name: '请输入配置名称',
        validate_name_too_long: '配置名称过长',
        validate_ssid: '请输入ssid',
        validate_ssid_too_long: 'ssid过长',
        validate_safe_type: '请选择安全类型',
      },
      pushRecord: {
        btn_back: "返回",
        title_record: "操作记录",
        table_push_type_all: "全局推送",
        table_push_type_part: "部分推送",
        table_btn_check: "查看推送内容",
        table_btn_range: "查看推送范围",
        modal_detail: "推送内容",
        table_column_name: '配置名称',
        table_column_operator: '操作人',
        table_column_version: '版本号',
        table_column_push_type: '推送类型',
        table_column_push_range: '推送范围',
        table_column_operate_time: '操作时间',
        table_column_operate: '操作',
      },
      tableColumn: {
        push_status_unpushed: '未推送',
        push_status_unpushed1: 'TID/SN推送',
        push_status_push: '已推送',
        btn_record: '记录',
        column_config_name: '配置名称',
        column_push_status: '推送范围',
        column_handle_status: '状态',
        column_finis_status: '完成状态',
        operation: '操作',
        column_push_type_all: '全局推送',
        column_push_type_part: '部分推送',
        query_finish_placeholder: '请输入机构名称关键字',
        query_finish_placeholder1: '请输入SN号关键字',
        query_finish_placeholder2: '请输入机构名称关键字，按下回车键执行搜索',
        query_finish_placeholder3: '请输入SN号关键字，按下回车键执行搜索',
        modal_title: '查询推送范围',
        modal_table_column: '机构名称',
        modal_table_column2: '是否生效',
        modal_table_column1: 'SN',
        finish_status_modal_title: '完成状态',
        finish_status_modal_search_placeholder: '请输入SN号/设备所属机构',
        finish_status_modal_re_push: '重新推送',
        finish_status_modal_re_push_msg: '重新推送配置成功',
        finish_status_modal_export: '导出报表',
        finish_status_modal_select_success: '执行成功',
        finish_status_modal_select_failure: '执行失败',
        finish_status_modal_select_unhandle: '未执行',
        finish_status_modal_table_column_org: '机构名称',
        finish_status_modal_file_name_success: '执行成功设备列表',
        finish_status_modal_file_name_failure: '执行失败设备列表',
        finish_status_modal_file_name_unhandle: '未执行设备列表',
        push_btn: '推送',
        push_modal_title: '选择推送范围',
        push_modal_cancel: '取消',
        push_modal_confirm: '推送',
        push_modal_validate: '请选择至少一个推送范围',
        push_modal_validate1: '操作成功',
        detail_btn: '查看',
        detail_modal_title: '查看配置详情',
        clone_btn: '克隆',
        delete_btn: '删除',
        delete_modal_title: '删除WIFI配置',
        delete_modal_msg: '删除该配置，将同时在设备上清除该配置，确认继续删除？',
        delete_modal_cancel: '取消',
        delete_modal_confirm: '删除',
      }
    },

    wifiWhitelist:{
      wifi_whitelist_setting:'WIFI白名单设置',
      ssid:'SSID',
      wifi_name:'名称',
      wifi_name_tip:'请输入名称',
      pus_range:'推送范围',
      version:"版本",
      status:'状态',
      execution_progress:'执行进度',
      operate:'操作',

      not_push:'未推送',
      already_push:'已推送',
      qr_code_generate_tip:'请填写设置信息后再生成二维码',
      qr_code_generate:'生成二维码',
      qr_code_generate_new_tip:'点击生成WIFI连接二维码，设备端可通过扫描二维码，连接对应的网络',
      wifi_setting_push:'WIFI设置推送',
      config_push:'推送',
      config_edit:'编辑',


      delete_apn_config_batch:'删除APN配置',
      delete_apn_config_batch_tip:'删除APN配置，设备端配置信息也随之删除，设备恢复原始设置，是否删除？',

      delete_wifi_config_batch:'删除WIFI配置',
      delete_wifi_config_batch_tip:'删除WIFI配置，设备端配置信息也随之删除，设备恢复原始设置，是否删除？',
      yes:'是',
      no:'否',

      add_wifi_whitelist:'WIFI白名单添加',
      whitelist_ssid:'白名单SSID',
      whitelist_ssid_tip1:'推送白名单后，设备仅可连接白名单的WIFI',
      whitelist_ssid_tip2:'(WiFi设置中的SSID默认加入白名单)；',
      whitelist_ssid_tip3:'若不推送白名单，WiFi连接不受限制。',
      whitelist_ssid_tip0:'请输入白名单SSID,不同SSID之间使用逗号分开,例:WIFI11,WIFI22,WIFI33',

      delete_wifi_whitelist_config_batch:'删除WIFI白名单配置',
      update_wifi_whitelist_no_ssid_delete:'此操作删除白名单规则中所有的白名单WIFI，白名单规则也会同步删除，',
      delete_wifi_whitelist_config_batch_tip1:'删除WIFI白名单配置，',
      delete_wifi_whitelist_config_batch_tip:'设备端配置信息也随之删除，设备恢复原始设置，是否删除？',
      wifi_whitelist_config_edit_tip:'WIFI白名单设置修改',
      wifi_whitelist_config_history_push:'Wifi白名单历史推送内容',
      wifi_whitelist_config_push:'WIFI白名单推送',
      push_wifi_whitelist_config_batch_tip:'推送WIFI白名单配置，是否推送？',


      enterPositiveInt:'请输入正整数',

      wifi_whitelist_select_group_error:'请选择一个设备分组',

      wifi_whitelist_ssid:'白名单网络名称',

      wifi_whitelist_group_wifi_ssid:'分组中WIFI配置内的SSID',
      wifi_whitelist_group_wifi_ssid_new:'手动添加',

      wifi_whitelist_group_ssid_list:'WIFI 配置内的SSID',

      wifi_whitelist_look_more:'查看更多',

      wifi_whitelist_name_default:'我的WIFI白名单',

      wifi_whitelist_name_is_exists:'请输入规则名称',

      wifi_whitelist_push_range_is_exists:'请选择推送范围',

      wifi_whitelist_ssid_name_is_exists:'请添加白名单wifi的网络名称',

      wifi_whitelist_ssid_empty:'无信息',

    },

    apnConfig: {
      tab_name: 'APN配置',
      addOne: {
        btn_name_edit: '编辑',
        btn_name_add: '添加',
        btn_name_clone: '克隆',
        modal_title_one: '添加APN配置',
        modal_title_one1: '编辑APN配置',
        modal_title_two: 'APN配置详情',
        form_config_name: '配置名称',
        form_apn_name: 'APN名称',
        form_agent: '代理',
        form_port: '端口',
        form_username: '用户名',
        form_password: '密码',
        form_server: '服务器',
        form_mmsagent: '彩信代理',
        form_mmsport: '彩信端口',
        form_authentication_type: '身份验证类型',
        form_apn_type: 'APN类型',
        form_apn_protocol: 'APN协议',
        form_btn_cancel: '取消',
        form_btn_ok: '添加',
        form_btn_ok1: '编辑',
        validate_port: '请输入正确的端口号',
        validate_config_name: '请输入配置名称',
        validate_config_name_one: '配置名称应少于50个字符',
        validate_apn_name: '请输入APN名称',
        validate_apn_name_one: 'APN名称应少于200个字符',
        validate_apn: '请输入APN',
        validate_apn_one: 'APN应少于200个字符',
        validate_mcc: '请输入MCC',
        validate_mcc_one: 'MCC应少于200个字符',
        validate_mnc: '请输入MNC',
        validate_mnc_one: 'MNC应少于200个字符',
        validate_agent: '代理应少于200个字符',
        validate_username: '用户名应少于200个字符',
        validate_password: '密码应少于200个字符',
        validate_server: '服务器应少于200个字符',
        validate_mmsc: 'MMSC应少于200个字符',
        validate_mms_agent: '彩信代理应少于200个字符',
        validate_apnType: 'APN类型应少于200个字符',
        authentication_type_null: '无',

      },
      delete: {
        title: '删除配置'
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        apn_name: 'APN名称',
        push_type: '推送范围',
        push_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
      }
    },
    customDesk: {
      name: '名称',
      cusDeskType: '桌面类型',
      configMethod:'配置方式',
      desktopName:'桌面名称',
      adminPassword:'管理员密码',
      desktopAppPackage:'桌面应用包名',
      appIconSize:'应用图标大小',
      small:'小',
      normal:'常规',
      nax:'大',
      oversized:'超大',
      btn_edit: '编辑',
      tab_name: '自定义桌面',
      add_modal_title_one: '添加自定义桌面',
      add_modal_title_one1: '编辑自定义桌面',
      add_modal_title_one2: '克隆自定义桌面',
      add_modal_title_two: '自定义桌面详情',
      add_modal_config_name: '配置名称',
      add_modal_apk: '模板文件',
      add_modal_config: '配置方式：',
      add_modal_tip: '请上传apk格式文件最大支持100M',
      add_modal_btn_cancel: '取消',
      add_modal_btn_create: '添加',
      add_modal_btn_edit: '编辑',
      validate_config_name: '请输入配置名称',
      validate_config_name_long: '配置名称应该少于50个字符',
      validate_apk_name: '请上传APK文件',
      validate_file_format: '文件格式错误',
      validate_file_upload_error: 'APK文件上传失败',
      validate_file_more: 'APK文件过大',
      config_status_effect: '生效',
      config_status_invalid: '不生效',
      table_column_config_name: '配置名称',
      table_column_apk_name: '桌面名称',
    },
    file_distribution: {
      edit: '编辑',
      view_title:'文件分发查看',
      device_groupDevice_fileDistribution:'创建文件分发',
      device_groupDevice_fileDistribution1:'编辑文件分发',
      device_groupDevice_tip7:'一次仅可分发一个文件',
      device_groupDevice_tip10:'如上为设备端文件存储的指定路径!',
      device_groupDevice_fileUpload:'文件上传：',
      delete_upload_file_tip:'请删除下方文件后重新上传文件',
      device_groupDevice_uploadFile:'上传文件',
      device_groupDevice_tip8:'文件大小不超过100M,文件分发后不可撤回,请慎重!',
      device_groupDevice_targetPath:'目标路径：',
      device_groupDevice_tip9:'格式如：/sdcard/MDM',
      device_groupDevice_fileRule:'文件规则：',
      button_cancel:'取消',
      button_confirm:'确定',
      button_confirm1:'编辑',
      device_groupDevice_coverOriginal:'覆盖原有文件',
      device_groupDevice_tip12:'下载成功后提示对方',
      device_groupDevice_tip15:'请上传需要分发的文件!',
      device_groupDevice_tip16:'请输入正确的目标路径!',
      device_groupDevice_tip17:'请输入配置名称!',
      device_groupDevice_tip18:'请勾选文件规则!',

      operation_success:'操作成功',
      file_send_size_rule : '导入文件不得超过100MB',
      delete_file:'删除文件分发',
      delete_file_tip:'确定要删除选中的分拣分发？',
      tab_name:"文件分发",
      add:"添加",
      delete:"删除",
      upload_file:'文件上传',
      target_path:'目标路径',
      file_rule:'文件规则',
      cover_file:'覆盖原有文件',
      tip_user:'下载成功后提示对方',
      config_name:'配置名称：',
      download_file:'原文件',
      download:'下载',
      enter_config_name:'请输入规则名称',

    },
    function_setting:{
      default_name:'功能设置',
      push_config:'推送',
      view_config:'查看',
      edit_config:'编辑',
      record_config:'记录',
      clone_config:'克隆',
      part_push:'部分推送',
      all_push:'全部推送',
      has_pushed:'已推送',
      no_push:'未推送',
      column_name:'配置名称',
      push_range:'推送范围',
      push_status:'推送状态',
      finish_status:'完成状态',
      create_time:'创建时间',
      operation:'操作',
      delete_function_tip:'确定要删除选定的功能设置?',
      delete_function_title:'删除功能设置',
      add_modal_title:'功能设置添加',
      edit_modal_title:'功能设置编辑',
      view_function_title:'查看功能设置',
      tab_name:'功能设置',
      add_rule:'添加',
      delete_rule:'删除',
      view_functionSetting:'查看功能设置',
      rule_name:"规则名称",
      fcSetting_home_disable: "禁用Home键",
      fcSetting_dropDown_disable: "禁用下拉状态栏",
      fcSetting_bluetooth_disable: "禁用蓝牙",
      fcSetting_wifi_disable: "禁用WIFI",
      fcSetting_MobileTraffic_disable: "禁用移动流量",
      fcSetting_ThirdPartyApplicationInstallation_disable: "禁用第三方应用安装",
      fcSetting_camera_disable: "禁用相机",
      fcSetting_tel_disable: "禁用电话",
      fcSetting_message_disable: "禁用短信",
      fcSetting_gps_disable: "禁用GPS",
      fcSetting_adb_disable: "禁用ADB",
      fcSetting_usb_disable: "禁用USB",
      fcSetting_input_disable: "禁用输入法弹出",
      fcSetting_restoreFactory_disable: "禁用恢复出厂设置",
      fcSetting_sd_disable: "禁用SD卡",
      button_confirm:'确定',
      button_cancel:'取消',
      operation_success : '操作成功',
      function_ruleName:"规则名称不能为空",
      yes: '是',
      no : '否',
      no_handle:"不处理",
      close:'关闭',
      on:'开启',
      off:'关闭',
      clone_tip0:'功能设置克隆',
      clone_confirm_tip:'确定要克隆此功能设置吗?',
      tip:'提示',
      clone_cancel_tip:'确定取消克隆功能设置吗?',
    },

    address_fence:{
      tab_name:'地理围栏',
      rule_name:'规则名称',
      rule_push_range:'推送范围',
      fences_range:'围栏范围',
      fences_range_lng:'围栏经度',
      fences_range_lat:'围栏纬度',
      fences_range_radius:'围栏半径',
      meter:'米',
      fence_switch:"围栏开关",
      close:"关闭",
      open:"开启",
      out_of_range_limit:'超出范围限制',
      device_disabled:'设备禁用',
      add:'添加',
      delete_rule:'删除',
      push_content111:'推送内容',
      email_frequency:"邮件发送频率",
      receiving_mailbox:"接收邮箱",
      save:'保存',
      cancel:'取消',

      table_rule_name:'配置名称',
      table_fence:'围栏',
      table_push_range:'推送范围',
      table_status:'状态',
      table_complete_schedule:'完成进度',
      table_operate:'操作',
      push:'推送',
      view:'查看',
      edit:'编辑',
      record:'记录',

      push_part:'部分推送',
      push_all:'全部推送',

      hour:'小时',

    },

    bootAnimation:{
      save:'确定',
      tab_name:"开机动画",
      delete_rule:"删除",
      btn_name_add:"添加",
      table_rule_name:"配置名称",
      table_rule_version:"配置版本",
      table_rule_push_range:"推送范围",
      table_rule_push_status:"推送状态",
      table_rule_finish_status:"执行状态",
      table_rule_create_time:"创建时间",
      table_rule_update_time:"修改时间",
      table_rule_operate:"操作",
      table_rule_animation_type:"动画类型",
      push_range_group:"分组推送",
      push_range_tid_sn:"TID/SN推送",
      push_range_all:"全局推送",
      handle_status_unpushed:"未推送",
      handle_status_pushed:"已推送",
      animation_type_default:"默认动画",
      animation_type_zip:"上传压缩包",
      clone_tip:'您将要克隆此开机动画,是否继续?',

      error_upload_file_format_size:"上传文件需zip文件，且最大20M",
    },

    messagePush:{
      tab_name: '消息推送',
      edit: '消息推送编辑',
      addOne: {
        btn_name_edit: '编辑',
        btn_name_add: '添加',
        modal_title_one: '添加推送消息',
        modal_title_one1: '编辑推送消息',
        modal_title_two: '推送消息详情',
        validate_config_name: '请输入配置名称',
        validate_message:'请输入推送的消息',
        btn_name_clone: '克隆',
        form_config_name: '配置名称：',
        form_message: '推送消息：',
        form_btn_cancel: '取消',
        form_btn_ok: '添加',
        authentication_type_null: '无',
        form_btn_ok1: '编辑',
      },
      delete: {
        title: '删除配置'
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        push_message:'消息内容',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',

        operation: '操作',
        validate_config_name_one: '配置名称应少于50个字符',
        validate_config_message_one: '消息内容不超过255个字符'
      }
    },
    unInstallDeviceApp:{
      tab_name: '应用卸载',
      addOne: {
        btn_name_edit: '编辑',
        btn_name_add: '添加',
        modal_title_one: '添加卸载应用',
        modal_title_one1: '编辑卸载应用',
        modal_title_two: '卸载应用详情',
        validate_config_name: '请输入配置名称',
        validate_unInstall:'请输入卸载应用',
        btn_name_clone: '克隆',
        form_config_name: '配置名称',
        form_message: '卸载应用',
        form_btn_cancel: '取消',
        form_btn_ok: '添加',
        authentication_type_null: '无',
        form_btn_ok1: '编辑',
        validate_config_name_one: '配置名称应少于50个字符',
      },
      delete: {
        title: '删除配置'
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        unInstallType:'卸载方式',
        unInstallPackageName:'卸载应用',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        unInstallType_Name1:'按应用名卸载',
        unInstallType_Name2:'按包名卸载',
        operation: '操作',
        validate_config_name_one: '配置名称应少于50个字符',
        validate_config_message_one: '消息内容不超过300个字符'
      }
    },
    lockScreenPassword:{
      tab_name: '密码下发',
      add: '新增',
      add_password: '新增密码规则',
      edit: '编辑',
      edit_password: '编辑密码规则',
      view: '查看',
      view_password: '查看密码规则',
      cancel:'取消',
      confirm:'确定',
      config_name: '配置名称',
      password_type: '密码类型',
      lock_screen_password: '锁屏密码',
      dynamic_password: '动态密码',
      validate_config_name: '请输入配置名称',
      validate_password_type:'请选择密码类型',
      validate_password_null:'请输入密码',
      validate_password: '请输入6-12位数字密码',
      select_both:'全下发',
      select_lock_screen_password:'锁屏密码下发',
      select_dynamic_password:'动态密码下发',
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        lock_screen_password:'锁屏密码',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
        validate_config_name_one: '配置名称应少于50个字符',
        validate_config_message_one: '锁屏密码内容不超过255个字符'
      }
    },
    advertisement:{
      tab_name: '广告',
      edit: '编辑广告',
      addOne: {
        btn_name_edit: '编辑',
        btn_name_view: '查看',
        btn_name_add: '添加',
        modal_title_one: '添加广告',
        modal_title_one1: '编辑广告',
        modal_title_adv_details: '广告详情',
        form_adv_config_name: '配置名称：',
        validate_form_adv_config_name: '请输入配置名称',
        validate_form_adv_image_header: '请上传Image Header,类型为jpg、png、jpeg',
        validate_form_adv_image_slider:'请上传Image Slider,类型为jpg、png、jpeg',
        upload_image_error:'图片上传出错',
        form_message: '广告：',
        form_btn_cancel: '取消',
        form_btn_ok: '添加',
        authentication_type_null: '无',
        form_btn_ok1: '编辑',
        advertisement:'广告',
        viewAdvPic:'查看图片',
        form_adv_image_header:'Image Header：',
        addSlider:'添加Slider',
        deleteSlider:'删除',
        uploadImageHeader:'上传Header',
        uploadSliderPic:'上传Slider',
        adv_content_max_size_is_8:'Slider最大个数为8个',
        adv_content_is_have_one:'至少有一个Slider',
        adv_content_is_have_one_slider:'至少上传一张Slider图片',
        adv_header_imge_size:'请上传Image Header',
        adv_slider_imge_size:'请上传Image Slider',
      },
      delete: {
        title: '删除配置'
      },
      table: {
        push_modal_title_adv_details: '推送广告详情',
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        advertisement:'广告',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
        validate_config_name_one: '配置名称应少于50个字符',
        validate_config_message_one: '广告内容不超过255个字符'
      }
    },
  },
  // 霸屏应用
  occupyScreen: {
    add: {
      title: '创建霸屏应用',
      title1: '编辑霸屏应用',
      form_name: '配置名称：',
      form_name_placeholder: '请输入配置名称',
      form_push_range: '推送范围',
      form_push_range_placeholder: '请选择推送范围',
      form_push_range_btn: '推送范围',
      form_pwd: '解锁密码：',
      form_pwd_placeholder: '请输入解锁密码(4位数字)',
      form_app: '应用选择：',
      form_cancel: '取消',
      form_create: '创建',
      form_edit: '编辑',
      form_app_version: '版本:',
      modal_title: '选择推送范围',
      modal_cancel: '取消',
      modal_confirm: '确定',
      modal1_title: '选择霸屏应用',
      modal1_search: '应用名称',
      modal1_select: '选择应用',
      validate_name_empty: '配置名称不能为空',
      validate_orgName_empty: '推送范围不能为空',
      validate_lockPwd_empty: '解锁密码不能为空',
      validate_lockPwd_er: '请输入4位数字密码',
      validate_app_empty: '霸屏应用不能为空',
      msg_add_success: '添加配置成功',
      msg_edit_success: '编辑配置成功',
    },
    table: {
      column_config_name: '配置名称',
      column_occupy_app_name: '霸屏应用',
      column_push_range: '推送范围',
      column_status: '状态',
      column_finish_status: '完成度',
      column_operation: '操作',
      column_push: '推送',
      show_detail: '查看',
      show_modal_title: '霸屏应用详情',
    },
  },
  // 批量解绑设备
  batchUnbind: {
    btn_name: '批量解绑',
    header_tip: '批量解绑设备',
  },
  // 设备生命周期
  deviceLifeCycle: {
    overview: '设备数据总览',
    overview_input: '已录入设备(台)',
    overview_register: '已激活设备(台)',
    search_form_sn: 'SN:',
    search_form_dvcType: '设备类型:',
    search_form_inputTime: '录入时间:',
    search_form_registerTime: '激活时间:',
    search_form_btn_search: '查询',
    search_form_btn_export: '导出',
    table_column_sn: 'SN',
    table_column_sn_placeholder: '请输入SN号',
    table_column_dvcType: '设备类型',
    table_column_dvcType_placeholder: '请选择设备类型',
    table_column_inputTime: '录入时间',
    table_column_registerTime: '激活时间',
    table_column_inputTime_createDate:'请选择录入时间',
    table_column_inputTime_registerDate:'请选择激活时间',
    table_column_inputTime_begin: '开始时间',
    table_column_inputTime_end: '结束时间',
    table_column_orgName: '当前所属机构(商户)',
  },
  // 用户角色权限
  authority: {
    form_header: '创建角色',
    form_header_edit:'编辑角色',
    role_name_label: '角色名称:',
    role_name_error1: '角色名称为必填字段',
    role_name_error2: '角色名称不能超过50个字符',
    placeholder_1: '请输入角色名称',
    remark_label: '备注:',
    is_default: '默认角色:',
    remark_placeholder: '请输入备注信息',
    remark_error1: '备注信息不能超过100个字符',
    form_btn_cancel: '取消',
    form_btn_OK: '确定',
    is_default_yes: '是',
    is_default_no: '否',
    tab_user: '用户',
    tab_role: '角色',
    tab_menu: '菜单',
    user_form_account: '账号',
    user_form_org: '所属机构/商户',
    user_form_role: '已拥有角色',
    user_form_option: '操作',
    user_form_option_point: '分配角色',
    allocate_modal_header: '分配角色',
    allocate_form_role_name: '角色名称',
    allocate_form_option: '操作',
    allocate_delete: '删除',
    allocate_cancel: '取消',
    allocate_ok: '确定',
    role_btn_create: '创建',
    role_btn_delete: '删除',
    role_column_isDefault_true: '是',
    role_column_isDefault_false: '否',
    role_btn_edit: '编辑',
    role_btn_allocate: '分配菜单',
    role_column_name: '角色名称',
    role_column_default: '默认角色',
    role_column_remark: '备注',
    role_column_option: '操作',
    role_column_create_time: '创建时间',
    role_column_update_time: '更新时间',
    role_column_create_user: '创建者',
    role_delete_title: '提示',
    role_delete_tip: '删除角色将导致拥有此角色的用户失去相应权限，确定删除吗？',
    role_allocate_modal_title: '分配菜单',
    role_allocate_modal_cancel: '取消',
    role_allocate_modal_ok: '确定',
    role_allocate_modal_error1: '请至少勾选一个菜单',
    role_allocate_title: '提示',
    role_allocate_tip: '确定要分配勾选的权限吗?',
    menu_tree_placeholder: '输入关键字进行过滤',
    menu_tree_all: '全选',
    menu_tree_parent: '父子关联',
    menu_detail_name: '菜单详情:',
    menu_form_parent_code: '父菜单编号:',
    menu_form_parent_name: '父菜单名称:',
    menu_form__code: '菜单编号:',
    menu_form_btn_select: '选择父菜单',
    menu_form_path: '菜单路径:',
    menu_form_auth: '校验字符串:',
    menu_form_remark: '备注:',
    menu_form_i18: '国际化字符串:',
    menu_form_order: '顺序值:',
    menu_form_edit: '编辑菜单',
    menu_form_create: '创建菜单',
    menu_form_delete: '删除菜单',
    menu_form_error1: '请选择父菜单',
    menu_form_edit_title: '提示',
    menu_form_edit_tip: '确定要提交更新?',
    menu_form_delete_tip: '确定要删除该菜单?',
    menu_selector_title: '选择菜单',
    menu_create_parent_placeholder: '请选择父菜单',
    menu_create_parent_placeholder1: '请选择父菜单',
    menu_create_path_placeholder1: '请输入菜单路径',
    menu_create_auth_placeholder1: '请输入校验字符串',
    menu_create_note_placeholder1: '请输入备注信息',
    menu_create_i18_placeholder1: '请输入国际化字符串',
    menu_create_order_placeholder: '请输入顺序数值',
    menu_create_title: '创建菜单',
    menu_form_path_val: '菜单路径不能为空',
    menu_form_path_val1: '菜单路径不能超过50个字符',
    menu_form_auth_val: '菜单校验字符串不能为空',
    menu_form_auth_val1: '菜单校验字符串不能超过50个字符',
    menu_form_i18_val: '国际化字符串不能为空',
    menu_form_order_val: '顺序数值不能为空',
    menu_form_order_val1: '顺序数值只能为数字',
    menu_form_i18_val1: '国际化字符串不能超过100个字符',
    menu_form_remark_val1: '备注信息不能超过100个字符',
    reset_password:'密码',
    reset_password_repeat:'重复密码',
    enter_password: '请输入密码',
    password_rule: '密码至少包含一个大写字母，一个数字，一个特殊字符，并且长度在8-20之间',
    password_not_match: '两次密码不一致',
    user_unlock: '解锁',
    user_lock: '锁定',
    user_unlocked_tip: '是否解锁账号'
  },
  dvcLocate: {
    file_name: '设备位置信息',
    search_txt: '筛选',
    search_org: '组织机构',
    search_time: '选择时间',
    search_location: '位置',
    search_close: '收起',
    search_export: '导出',
    search_search: '筛选',
    search_reset: '重置',
    header: '设备位置变化',
    header_desc: '根据设备的位置变化，位置发生变化及时预警，有效的判断设备的合规性',
    column_history_location: '查看历史轨迹',
    column_org: '产权机构',
    column_time: '记录时间',
    column_tracking: '设备轨迹',
    modal_cancel: '取消',
    modal_ok: '确定',
  },
  netConnection: {
    file_name: '网络连接分析',
    search_channel: '频道',
    header: '网络连接分析',
    desc: '基于设备网络情况对整个环境下网络AP进行数据分析，统计每个 ap ，信号状态和设备连接ap次数统计',
    col_channel: 'AP频道',
    col_avg: '平均网络强度（dBm）',
    col_lowest: '最低网络强度（dBm）',
    col_highest: '最高网络强度（dBm）',
  },
  dvcConnInfo:{
    title:'设备连接异常分析',
    content:'针对设备在工作环境下，根据PING包情况对设备wifi 信号质量进行数据统计分析，有效的判断作业环境下网络状态和设备状态。请注意，频繁采集会影响工作使用，建议采集频率＞1h。',
    query:{
      snOrTid:'SN/TID:',
      networkDelayAvg: '平均时延:',
      exceptionTimes: '异常次数:',
      location:'位置:',
      orgName:'组织机构:',
      time:'选择时间:',
    },
    orgName: '产权机构',
    ssid: 'SSID',
    networkDelayAvg: '平均时延(ms)',
    networkDelayMax: '最大时延(ms)',
    packetLossTimes: '丢包次数',
    exceptionTimes: '异常次数',
    exportTitle:'设备连接信息异常报表',
    message: {
      plsSelectDate: '请选择查询日期的范围',
    },
  },

  aliveDevice:{
    data_x_line:"横坐标间隔",
    alive_device_situation:"活跃情况",
    alive_device_mouth_num:"本月设备活跃度",
    alive_device_week_num:"本周设备活跃度",
    alive_device_num:"活跃设备数",
    exportTitle:'设备活跃数量报表',
    hour:"小时",
    day:"天",
  },

  // OTP相关
  otp: {
    btn_single: '单件入库',
    btn_batch: '批量入库',
    btn_send: '发送',
    btn_export: '导出',
    filter: '过滤器',
    filter_search: '查询',
    mobile_number: '电话',
    status: '状态',
    status_unfinished: '未完成',
    status_unsent: '未发送',
    status_sent: '已发送',
    status_activate: '已激活',
    status_activate_fail: '激活失败',
    status_sent_fail: '发送失败',
    sent_date: '发送日期',
    merchant: '机构',
    operate_sent: '发送',
    operate_edit: '编辑',
    operate_unbind: '解绑',
    operate_record: '记录',
    form_mobile_number: '电话',
    form_status: '状态',
    form_sent_date: '发送日期',
    form_operate: '操作',
    form_operate_time: '操作时间',
    model_edit: '编辑',
    btn_cancel: '取消',
    btn_ok: '确定',
    confirm: '提示',
    edit_confirm_title: '确定提交更新吗？',
    model_single_import: '单件入库',
    model_record: '历史记录',
    msg_tid: 'tid必须是八位数字',
    msg_tid_duplicate: 'tid已存在',
    confirm_export: '是否导出OTP列表数据?',
    confirm_batch_sent: '是否发送OTP到指定电话?',
    confirm_unbind: '是否解除SN与TID的绑定关系?',
  },
  mas: {
    confirm_modal_title: '确认信息',
    tip1: '未重复数据已录入，以下设备已存在，请确认是否更新数据。',
    tip2: '更新: 更新选中设备的信息，覆盖原始数据',
    tip3: '删除: 删除选中设备的信息，原始数据不会被修改',
    btn_delete: '删除',
    btn_delete1: '删除所选',
    btn_update: '更新',
    btn_update1: '更新所选',
    col_operation: '操作',
    tip_title: '提示',
    clear: '关闭弹窗将清空未录入的重复数据',
    update: '确定要更新选择项？',
    delete: '确定要删除选择项？',
  },
  paramDict: {
    type_input: '输入框',
    type_switch: '开关',
    type_select: '单选',
    type_select_multi: '多选',
    create: '添加',
    search: '查询',
    reset: '重置',
    add_modal_title: '创建字典',
    add_modal_name: '名称',
    add_modal_type: '类型',
    add_modal_default: '默认值',
    add_modal_switch_yes: '是',
    add_modal_switch_no: '否',
    add_modal_source: '可选数据',
    add_modal_remark: '备注',
    add_modal_enable: '激活',
    add_modal_submit: '提交',
    add_modal_delete: '删除',
    add_modal_add: '添加数据项',
    edit_modal_title: '编辑字典',
    edit_modal_btn_edit: '编辑',
    edit_modal_btn_delete: '删除',
    edit_modal_btn_all: '选择全部',
    edit_modal_btn_reverse: '反向选择',
    edit_modal_btn_delete_all: '删除所选',
    col_name: '名称',
    col_type: '类型',
    col_default: '默认值',
    col_remark: '备注',
    col_operation: '操作',
    col_enable: '激活',
    del_title: '删除确认',
    del_tip: '您确认要删除选择项？',
    change_enable: '切换确认',
    change_tip: '您确认要改变激活状态？',
  },
  paramDictManage: {
    search_location: '位置',
    search_dvcType: '设备类型',
    col_modify: '列表布局',
    col_modify_tip: '页面显示字段，选中的字段在参数管理页面直接显示',
    col_all: '全选',
    no_configured: '未配置',
    configured: '已配置',
    configure: '参数配置',
    title_configure: '是否配置',
    title_operation: '操作',
    set_name: '名称',
    set_type: '类型',
    set_value: '值',
    set_remark: '备注',
    set_cancel: '取消',
    set_confirm: '确定',
  },
  dashboard:{
    device_total_num:"设备总数",
    alive_device:"在线设备",
    joined_in_seven_days:"七天内新加入",
    device_abnormal_status:"设备异常状态",
    device_need_charge:"需要充电的设备20%以下",
    device_disable:"禁用设备",
    device_offline:"离线设备",
    device_offline_over_forty_eight_hours:"离线超过48小时",
    device_report_over_forty_eight_hours:"信息上报超过48小时",
    device_map:"设备地图",
    warn_log:"警告日志",
    device_fence_warn_log:"围栏预警日志",
    warn:"警告",
    sn:"SN",
    org:"机构",
    record_time:"记录时间",
    device_fence_warn_tip:"设备离开设备围栏",

    alive_device_month:"本月设备活跃度",
    alive_device_week:"本周设备活跃度",
    alive_device_num:"活跃设备数",
    un_bind_device_num:"未绑定设备总数",
    bind_device_num:"已绑定设备总数",
    un_bind_device_count:"未绑定设备数",
    bind_device_count:"绑定设备数",

    export:"导出",
  },
  userManage: {
    placeholder: '输入用户名进行模糊查询',
    btn_search: '查询',
    btn_reset: '重置',
    create: '新增用户',
    enable: '启用',
    disable: '禁用',
    edit: '编辑',
    reset_pwd: '恢复默认密码',
    delete: '删除',
    col_status: '账户状态',
    col_ip: '常用IP',
    user_type:'用户类型',
    user_admin: '管理员',
    user_user: '用户',
    reset_title: '重置确认',
    reset_tip: '您确认重置该用户的密码吗？默认密码为',
    delete_title: '删除确认',
    delete_tip: '您确认删除指定用户吗',
    change_status_title: '切换确认',
    change_status_tip: '您确认要切换开关状态吗?',
    create_title: '新建用户',
    create_org: '所属机构',
    create_username: '用户名',
    create_password: '初始密码',
    create_role: '角色',
    create_cancel: '取消',
    create_confirm: '确定',
    create_validate_password: '请输入密码',
    create_validate_org: '请选择所属机构',
    create_validate_role: '请选择角色',
    edit_title: '编辑用户',
    reset_password_tip:'此操作会将该账号重置为输入的密码，是否继续？',
    reset_password: '重置密码',
  },
  firstLogin: {
    title: '请重新设置密码',
    logout: '退出登录',
    relogin: '重新登录',
    relogin_tip: '重新设置密码后，需要重新登录系统。',
    disable_title: '禁用警告',
    disable_tip: '该账号已被禁用，请联系上级机构重新启用账号！'
  },
  silent_app:{
    application_name:'应用选择',
    default_config_name:'默启应用',
    silentApp_push_config:'推送',
    view_btn:'查看',
    silentApp_edit_config:'编辑',
    silentApp_record_config:'记录',
    part_push:'部分推送',
    all_push:'全部推送',
    has_pushed:'已推送',
    no_push:'未推送',
    table_column_config_name:'配置名称',
    table_column_app_name: '默启应用',
    table_column_push_range:'推送范围',
    table_column_push_status:'推送状态',
    table_column_finis_status:'完成状态',
    create_time:'创建时间',
    table_column_operation:'操作',
    delete_function_tip:'确定要删除选定的功能设置?',
    delete_function_title:'删除功能设置',
    add_modal_title_name:'添加默启应用',
    edit_modal_title:'编辑默启应用',
    view_modal_title:'查看默启应用',
    tab_name:'功能设置',
    add_rule:'添加',
    delete_btn_rule:'删除',
    view_silent_app:'查看默启应用',
    rule_app_name:"规则名称",
    silentApp_version:"版本号",
    confirm_button:'确定',
    cancel_button:'取消',
    push_operation_success : '操作成功',
    validate_configName_empty:"规则名称不能为空",
    edit_operation_success:'编辑成功',
    yes: '是',
    no : '否',
    close:'关闭',
    on:'开启',
    off:'关闭',
    tip:'提示',
    form_application_version:'版本',
    validate_app_select_empty:'默启应用不能为空',
    config_name_no_more_than:'规则名称不超过32字符',
    modal2_title:'选择默启应用',
  },
  uruploader: {
    tip1: '支持文件类型：',
    tip2: '支持文件大小：不超过 ',
    tip3: '请不要修改模板文件标题行',
    tip4: '文件内容不能超过',
    tip4_1: '60001行',
    ignore_err: '忽略错误数据',
    ignore_err_selected: '勾选：',
    ignore_err_selected_tip: '程序将忽略模板中的错误数据，仅处理能处理的数据；',
    ignore_err_unselected: '不勾选：',
    ignore_err_unselected_tip: '程序仅仅在所有模板数据都正确时，处理数据；',
    download: '下载模板文件',
    batch_success: '文件上传成功，可在报表>批量任务查看导入进度',
    format_err: '仅支持 "xls"、"xlsx" 格式的文件',
    size_err: '仅支持不超过 10M 的文件',
  },
  bulk_task: {
    col_type: "任务类型",
    col_time_create: "任务创建时间",
    col_ignore_err: "忽略错误",
    col_status: "状态",
    col_status_pending: '执行中',
    col_status_complete: '导入成功',
    col_status_part_complete: '部分导入成功',
    col_status_fail: '导入失败',
    col_status_error: '处理异常',
    col_time_complete: '完成时间',
    import_success: '导入/成功',
    operator: '操作人',
    col_download_report: '下载错误报告',
    col_option: '操作',
    val_yes: '是',
    val_no: '否',
    type_org_add: '机构管理_批量入库',
    type_sn_apn_push: 'APN配置_SN推送',
    type_sn_wifi_push: 'WIFI配置_SN推送',
    type_sn_function_push: '功能设置_SN推送',
    type_sn_appDeploy_push: '应用部署_SN推送',
    type_sn_param_push: '参数配置_SN推送',
    type_sn_file_push: '文件分发_SN推送',
    type_sn_messagePush_push: '消息推送_SN推送',
    type_sn_deviceFence_push: '地理围栏_SN推送',
    type_sn_customDesk_push: '自定义桌面_SN推送',
    type_sn_occupyScreen_push: '霸屏应用_SN推送',
    type_sn_bootAnimation_push: '开机动画_SN推送',
    type_sn_silentApp_push: '默启应用_SN推送',
    type_sn_unInstall_push: '应用卸载_SN推送',
    type_sn_lockScreen_push: '锁屏密码_SN推送',
    type_sn_advertisement_push: '广告_SN推送',
    type_sn_strategy_push: '配置管理_SN推送',
    type_tid_apn_push: 'APN配置_TID推送',
    type_tid_wifi_push: 'WIFI配置_TID推送',
    type_tid_function_push: '功能设置_TID推送',
    type_tid_appDeploy_push: '应用部署_TID推送',
    type_tid_param_push: '参数配置_TID推送',
    type_tid_file_push: '文件分发_TID推送',
    type_tid_messagePush_push: '消息推送_TID推送',
    type_tid_deviceFence_push: '地理围栏_TID推送',
    type_tid_customDesk_push: '自定义桌面_TID推送',
    type_tid_occupyScreen_push: '霸屏应用_TID推送',
    type_tid_bootAnimation_push: '开机动画_TID推送',
    type_tid_silentApp_push: '默启应用_TID推送',
    type_tid_unInstall_push: '应用卸载_TID推送',
    type_tid_lockScreen_push: '锁屏密码_TID推送',
    type_tid_advertisement_push: '广告_TID推送',
    type_tid_strategy_push: '配置管理_TID推送',
    type_bulk_activation: '机构设备仓库_批量入库',
    type_bulk_move: '机构设备仓库_批量移库',
    type_bulk_bind: '机构设备仓库_批量绑定',
    type_bulk_delete: '机构设备仓库_批量删除',
    type_bulk_unbind: '机构设备仓库_批量解绑',
    type_bulk_otp: 'OTP批量入库',
    btn_search: '查询',
  },
  export_task: {
    task_tip: '导出操作可能耗费一点时间，结果将显示在{parMenu} >> {childMenu}',
    col_type: "任务类型",
    col_time_create: "任务创建时间",
    col_status: "状态",
    col_status_complete: '执行成功',
    col_status_fail: '执行失败',
    col_time_complete: '完成时间',
    operator: '操作人',
    col_download_report: '下载导出报告',
    no_report: '数据为空',
    col_option: '操作',
    val_yes: '是',
    val_no: '否',
    btn_search: '查询',
    type_abnormal_devices_need_charge: '异常设备_需要充电',
    type_abnormal_devices_disabled: '异常设备_禁用',
    type_abnormal_devices_offline: '异常设备_离线',
    type_abnormal_devices_offline_two_days: '异常设备_离线超过48小时',
    type_abnormal_devices_unreport_two_days: '异常设备_超出48小时未上传信息',
    type_app_param_unhandled: '参数配置_未完成设备',
    type_app_param_success: '参数配置_已完成设备',
    type_app_param_failure: '参数配置_执行失败设备',
    type_app_deploy_unhandled: '应用部署_未完成设备',
    type_app_deploy_success: '应用部署_已完成设备',
    type_app_deploy_failure: '应用部署_执行失败设备',
    type_app_whitelist_unhandled: '应用白名单_未完成设备',
    type_app_whitelist_success: '应用白名单_已完成设备',
    type_app_whitelist_failure: '应用白名单_执行失败设备',
    type_app_survivalList_unhandled: '应用保活名单_未完成设备',
    type_app_survivalList_success: '应用保活名单_已完成设备',
    type_app_survivalList_failure: '应用保活名单_执行失败设备',
    type_terminal_detail: '设备详情',
    type_wifi_unhandled: 'WIFI配置_未完成设备',
    type_wifi_success: 'WIFI配置_已完成设备',
    type_wifi_failure: 'WIFI配置_执行失败设备',
    type_apn_unhandled: 'APN配置_未完成设备',
    type_apn_success: 'APN配置_已完成设备',
    type_apn_failure: 'APN配置_执行失败设备',
    type_file_distribution_unhandled: '文件分发_未完成设备',
    type_file_distribution_success: '文件分发_已完成设备',
    type_file_distribution_failure: '文件分发_执行失败设备',
    type_function_setting_unhandled: '功能设置_未完成设备',
    type_function_setting_success: '功能设置_已完成设备',
    type_function_setting_failure: '功能设置_执行失败设备',
    type_wifi_whitelist_unhandled: 'WIFI白名单_未完成设备',
    type_wifi_whitelist_success: 'WIFI白名单_已完成设备',
    type_wifi_whitelist_failure: 'WIFI白名单_执行失败设备',
    type_device_fence_unhandled: '地理围栏_未完成设备',
    type_device_fence_success: '地理围栏_已完成设备',
    type_device_fence_failure: '地理围栏_执行失败设备',
    type_message_push_unhandled: '消息推送_未完成设备',
    type_message_push_success: '消息推送_已完成设备',
    type_message_push_failure: '消息推送_执行失败设备',
    type_uninstall_app_unhandled: '应用卸载_未完成设备',
    type_uninstall_app_success: '应用卸载_已完成设备',
    type_uninstall_app_failure: '应用卸载_执行失败设备',
    type_lock_screen_password_unhandled: '锁屏密码下发_未完成设备',
    type_lock_screen_password_success: '锁屏密码下发_已完成设备',
    type_lock_screen_password_failure: '锁屏密码下发_执行失败设备',
    type_advertisement_unhandled: '广告_未完成设备',
    type_advertisement_success: '广告_已完成设备',
    type_advertisement_failure: '广告_执行失败设备',
    type_device_lifecycle: '设备生命周期',
    type_silent_app_unhandled: '默启应用_未完成设备',
    type_silent_app_success: '默启应用_已完成设备',
    type_silent_app_failure: '默启应用_执行失败设备',
    type_custom_desk_unhandled: '自定义桌面_未完成设备',
    type_custom_desk_success: '自定义桌面_已完成设备',
    type_custom_desk_failure: '自定义桌面_执行失败设备',
    type_occupy_screen_unhandled: '霸屏应用_未完成设备',
    type_occupy_screen_success: '霸屏应用_已完成设备',
    type_occupy_screen_failure: '霸屏应用_执行失败设备',
    type_boot_animation_unhandled: '开机动画_未完成设备',
    type_boot_animation_success: '开机动画_已完成设备',
    type_boot_animation_failure: '开机动画_执行失败设备',
    type_policy_management_unhandled: '配置管理_未完成设备',
    type_policy_management_success: '配置管理_已完成设备',
    type_policy_management_failure: '配置管理_执行失败设备',
    type_company_flow: '流量使用情况',
    type_device_app_flow: '应用排行',
    type_device_org_flow: '机构商户流量排行',
    type_device_org_flow_detail: '机构商户流量排行机构详情',
    type_device_location: '设备位置变化',
    type_device_conn_info: '设备连接分析',
    type_device_net_conn_analysis: '网络连接分析',
    type_device_alive_info: '设备活跃情况',
    type_device_app_install_statistics:'应用安装情况',
  },
  deviceApp_installStatistics: {
    file_name: "应用安装情况",
    sn: "SN",
    org_to_sn: "所属机构/商户",
    app_name: "应用名称",
    app_version_name: "版本名",
    export:'导出',
    operator: '操作人',
    btn_search: '查询',
    inputSn:'请输入设备编号',
    inputAppName:'请输入应用名称',
    inputAppVersionName:'请输入应用版本名称',
    reviewSn:'请输入设备编号',
    reviewAppName:'请输入应用名称',
    reviewAppVersionName:'请输入应用版本名称',
  },
}
export default message

